const pucList = [
  { value: 1, label: 'ACTIVO' },
  { value: 11, label: 'DISPONIBLE' },
  { value: 1105, label: 'CAJA' },
  { value: 110505, label: 'CAJA GENERAL' },
  { value: 110510, label: 'CAJAS MENORES' },
  { value: 110515, label: 'MONEDA EXTRANJERA' },
  { value: 1110, label: 'BANCOS' },
  { value: 111005, label: 'MONEDA NACIONAL' },
  { value: 111010, label: 'MONEDA EXTRANJERA' },
  { value: 1115, label: 'REMESAS EN TRANSITO' },
  { value: 111505, label: 'MONEDA NACIONAL' },
  { value: 111510, label: 'MONEDA EXTRANJERA' },
  { value: 1120, label: 'CUENTAS DE AHORRO' },
  { value: 112005, label: 'BANCOS' },
  { value: 112010, label: 'CORPORACIONES DE AHORRO Y VIVIENDA' },
  { value: 112015, label: 'ORGANISMOS COOPERATIVOS FINANCIEROS' },
  { value: 1125, label: 'FONDOS' },
  { value: 112505, label: 'ROTATORIOS MONEDA NACIONAL' },
  { value: 112510, label: 'ROTATORIOS MONEDA EXTRANJERA' },
  { value: 112515, label: 'ESPECIALES MONEDA NACIONAL' },
  { value: 112520, label: 'ESPECIALES MONEDA EXTRANJERA' },
  { value: 112525, label: 'DE AMORTIZACION MONEDA NACIONAL' },
  { value: 112530, label: 'DE AMORTIZACION MONEDA EXTRANJERA' },
  { value: 12, label: 'INVERSIONES' },
  { value: 1205, label: 'ACCIONES' },
  { value: 120505, label: 'AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: 120510, label: 'PESCA' },
  { value: 120515, label: 'EXPLOTACION DE MINAS Y CANTERAS' },
  { value: 120520, label: 'INDUSTRIA MANUFACTURERA' },
  { value: 120525, label: 'SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: 120530, label: 'CONSTRUCCION' },
  { value: 120535, label: 'COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: 120540, label: 'HOTELES Y RESTAURANTES' },
  { value: 120545, label: 'TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: 120550, label: 'ACTIVIDAD FINANCIERA' },
  { value: 120555, label: 'ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: 120560, label: 'ENSEÑANZA' },
  { value: 120565, label: 'SERVICIOS SOCIALES Y DE SALUD' },
  { value: 120570, label: 'OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES' },
  { value: 120599, label: 'AJUSTES POR INFLACION' },
  { value: 1210, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 121005, label: 'AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: 121010, label: 'PESCA' },
  { value: 121015, label: 'EXPLOTACION DE MINAS Y CANTERAS' },
  { value: 121020, label: 'INDUSTRIA MANUFACTURERA' },
  { value: 121025, label: 'SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: 121030, label: 'CONSTRUCCION' },
  { value: 121035, label: 'COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: 121040, label: 'HOTELES Y RESTAURANTES' },
  { value: 121045, label: 'TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: 121050, label: 'ACTIVIDAD FINANCIERA' },
  { value: 121055, label: 'ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: 121060, label: 'ENSEÑANZA' },
  { value: 121065, label: 'SERVICIOS SOCIALES Y DE SALUD' },
  { value: 121070, label: 'OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: 121099, label: 'AJUSTES POR INFLACION' },
  { value: 1215, label: 'BONOS' },
  { value: 121505, label: 'BONOS PUBLICOS MONEDA NACIONAL' },
  { value: 121510, label: 'BONOS PUBLICOS MONEDA EXTRANJERA' },
  { value: 121515, label: 'BONOS ORDINARIOS' },
  { value: 121520, label: 'BONOS CONVERTIBLES EN ACCIONES' },
  { value: 121595, label: 'OTROS' },
  { value: 1220, label: 'CEDULAS' },
  { value: 122005, label: 'CEDULAS DE CAPITALIZACION' },
  { value: 122010, label: 'CEDULAS HIPOTECARIAS' },
  { value: 122015, label: 'CEDULAS DE INVERSION' },
  { value: 122095, label: 'OTRAS' },
  { value: 1225, label: 'CERTIFICADOS' },
  { value: 122505, label: 'CERTIFICADOS DE DEPOSITO A TERMINO (C.D.T.)' },
  { value: 122510, label: 'CERTIFICADOS DE DEPOSITO DE AHORRO' },
  { value: 122515, label: 'CERTIFICADOS DE AHORRO DE VALOR CONSTANTE (C.A.V.C.)' },
  { value: 122520, label: 'CERTIFICADOS DE CAMBIO' },
  { value: 122525, label: 'CERTIFICADOS CAFETEROS VALORIZABLES' },
  { value: 122530, label: 'CERTIFICADOS ELECTRICOS VALORIZABLES (C.E.V.)' },
  { value: 122535, label: 'CERTIFICADOS DE REEMBOLSO TRIBUTARIO (C.E.R.T.)' },
  { value: 122540, label: 'CERTIFICADOS DE DESARROLLO TURISTICO' },
  { value: 122545, label: 'CERTIFICADOS DE INVERSION FORESTAL (C.I.F.)' },
  { value: 122595, label: 'OTROS' },
  { value: 1230, label: 'PAPELES COMERCIALES' },
  { value: 123005, label: 'EMPRESAS COMERCIALES' },
  { value: 123010, label: 'EMPRESAS INDUSTRIALES' },
  { value: 123015, label: 'EMPRESAS DE SERVICIOS' },
  { value: 1235, label: 'TITULOS' },
  { value: 123505, label: 'TITULOS DE DESARROLLO AGROPECUARIO' },
  { value: 123510, label: 'TITULOS CANJEABLES POR CERTIFICADOS DE CAMBIO' },
  { value: 123515, label: 'TITULOS DE TESORERIA (T.E.S.)' },
  { value: 123520, label: 'TITULOS DE PARTICIPACION' },
  { value: 123525, label: 'TITULOS DE CREDITO DE FOMENTO' },
  { value: 123530, label: 'TITULOS FINANCIEROS AGROINDUSTRIALES (T.F.A.)' },
  { value: 123535, label: 'TITULOS DE AHORRO CAFETERO (T.A.C.)' },
  { value: 123540, label: 'TITULOS DE AHORRO NACIONAL (T.A.N.)' },
  { value: 123545, label: 'TITULOS ENERGETICOS DE RENTABILIDAD CRECIENTE (T.E.R.)' },
  { value: 123550, label: 'TITULOS DE AHORRO EDUCATIVO (T.A.E.)' },
  { value: 123555, label: 'TITULOS FINANCIEROS  INDUSTRIALES Y COMERCIALES' },
  { value: 123560, label: 'TESOROS' },
  { value: 123565, label: 'TITULOS DE DEVOLUCION DE IMPUESTOS NACIONALES (TIDIS)' },
  { value: 123570, label: 'TITULOS INMOBILIARIOS' },
  { value: 123595, label: 'OTROS' },
  { value: 1240, label: 'ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: 124005, label: 'BANCOS COMERCIALES' },
  { value: 124010, label: 'COMPAÑIAS DE FINANCIAMIENTO COMERCIAL' },
  { value: 124015, label: 'CORPORACIONES FINANCIERAS' },
  { value: 124095, label: 'OTRAS' },
  { value: 1245, label: 'DERECHOS FIDUCIARIOS' },
  { value: 124505, label: 'FIDEICOMISOS DE INVERSION MONEDA NACIONAL' },
  { value: 124510, label: 'FIDEICOMISOS DE INVERSION MONEDA EXTRANJERA' },
  { value: 1250, label: 'DERECHOS DE RECOMPRA DE INVERSIONES NEGOCIADAS (REPOS)' },
  { value: 125005, label: 'ACCIONES' },
  { value: 125010, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 125015, label: 'BONOS' },
  { value: 125020, label: 'CEDULAS' },
  { value: 125025, label: 'CERTIFICADOS' },
  { value: 125030, label: 'PAPELES COMERCIALES' },
  { value: 125035, label: 'TITULOS' },
  { value: 125040, label: 'ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: 125095, label: 'OTROS' },
  { value: 125099, label: 'AJUSTES POR INFLACION' },
  { value: 1255, label: 'OBLIGATORIAS' },
  { value: 125505, label: 'BONOS DE FINANCIAMIENTO ESPECIAL' },
  { value: 125510, label: 'BONOS DE FINANCIAMIENTO PRESUPUESTAL' },
  { value: 125515, label: 'BONOS PARA DESARROLLO SOCIAL Y SEGURIDAD INTERNA (B.D.S.I.)' },
  { value: 125595, label: 'OTRAS' },
  { value: 1260, label: 'CUENTAS EN PARTICIPACION' },
  { value: 126099, label: 'AJUSTES POR INFLACION' },
  { value: 1295, label: 'OTRAS INVERSIONES' },
  { value: 129505, label: 'APORTES EN COOPERATIVAS' },
  { value: 129510, label: 'DERECHOS EN CLUBES SOCIALES' },
  { value: 129515, label: 'ACCIONES O DERECHOS EN CLUBES DEPORTIVOS' },
  { value: 129520, label: 'BONOS EN COLEGIOS' },
  { value: 129595, label: 'DIVERSAS' },
  { value: 129599, label: 'AJUSTES POR INFLACION' },
  { value: 1299, label: 'PROVISIONES' },
  { value: 129905, label: 'ACCIONES' },
  { value: 129910, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 129915, label: 'BONOS' },
  { value: 129920, label: 'CEDULAS' },
  { value: 129925, label: 'CERTIFICADOS' },
  { value: 129930, label: 'PAPELES COMERCIALES' },
  { value: 129935, label: 'TITULOS' },
  { value: 129940, label: 'ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: 129945, label: 'DERECHOS FIDUCIARIOS' },
  { value: 129950, label: 'DERECHOS DE RECOMPRA DE INVERSIONES NEGOCIADAS' },
  { value: 129955, label: 'OBLIGATORIAS' },
  { value: 129960, label: 'CUENTAS EN PARTICIPACION' },
  { value: 129995, label: 'OTRAS INVERSIONES' },
  { value: 13, label: 'DEUDORES' },
  { value: 1305, label: 'CLIENTES' },
  { value: 130505, label: 'NACIONALES' },
  { value: 130510, label: 'DEL EXTERIOR' },
  { value: 130515, label: 'DEUDORES DEL SISTEMA' },
  { value: 1310, label: 'CUENTAS CORRIENTES COMERCIALES' },
  { value: 131005, label: 'CASA MATRIZ' },
  { value: 131010, label: 'COMPAÑIAS VINCULADAS' },
  { value: 131015, label: 'ACCIONISTAS O SOCIOS' },
  { value: 131020, label: 'PARTICULARES' },
  { value: 131095, label: 'OTRAS' },
  { value: 1315, label: 'CUENTAS POR COBRAR A CASA MATRIZ' },
  { value: 131505, label: 'VENTAS' },
  { value: 131510, label: 'PAGOS A NOMBRE DE CASA MATRIZ' },
  { value: 131515, label: 'VALORES RECIBIDOS POR CASA MATRIZ' },
  { value: 131520, label: 'PRESTAMOS' },
  { value: 1320, label: 'CUENTAS POR COBRAR A VINCULADOS ECONOMICOS' },
  { value: 132005, label: 'FILIALES' },
  { value: 132010, label: 'SUBSIDIARIAS' },
  { value: 132015, label: 'SUCURSALES' },
  { value: 1325, label: 'CUENTAS POR COBRAR A SOCIOS Y ACCIONISTAS' },
  { value: 132505, label: 'A SOCIOS' },
  { value: 132510, label: 'A ACCIONISTAS' },
  { value: 1328, label: 'APORTES POR COBRAR' },
  { value: 1330, label: 'ANTICIPOS Y AVANCES' },
  { value: 133005, label: 'A PROVEEDORES' },
  { value: 133010, label: 'A CONTRATISTAS' },
  { value: 133015, label: 'A TRABAJADORES' },
  { value: 133020, label: 'A AGENTES' },
  { value: 133025, label: 'A CONCESIONARIOS' },
  { value: 133030, label: 'DE ADJUDICACIONES' },
  { value: 133095, label: 'OTROS' },
  { value: 1332, label: 'CUENTAS DE OPERACION CONJUNTA' },
  { value: 1335, label: 'DEPOSITOS' },
  { value: 133505, label: 'PARA IMPORTACIONES' },
  { value: 133510, label: 'PARA SERVICIOS' },
  { value: 133515, label: 'PARA CONTRATOS' },
  { value: 133520, label: 'PARA RESPONSABILIDADES' },
  { value: 133525, label: 'PARA JUICIOS EJECUTIVOS' },
  { value: 133530, label: 'PARA ADQUISICION DE ACCIONES, CUOTAS O DERECHOS' },
  { value: 133535, label: 'EN GARANTIA' },
  { value: 133595, label: 'OTROS' },
  { value: 1340, label: 'PROMESAS DE COMPRA VENTA' },
  { value: 134005, label: 'DE BIENES RAICES' },
  { value: 134010, label: 'DE MAQUINARIA Y EQUIPO' },
  { value: 134015, label: 'DE FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 134020, label: 'DE FLOTA Y EQUIPO AEREO' },
  { value: 134025, label: 'DE FLOTA Y EQUIPO FERREO' },
  { value: 134030, label: 'DE FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 134035, label: 'DE SEMOVIENTES' },
  { value: 134095, label: 'DE OTROS BIENES' },
  { value: 1345, label: 'INGRESOS POR COBRAR' },
  { value: 134505, label: 'DIVIDENDOS Y/O PARTICIPACIONES' },
  { value: 134510, label: 'INTERESES' },
  { value: 134515, label: 'COMISIONES' },
  { value: 134520, label: 'HONORARIOS' },
  { value: 134525, label: 'SERVICIOS' },
  { value: 134530, label: 'ARRENDAMIENTOS' },
  { value: 134535, label: 'CERT POR COBRAR' },
  { value: 134595, label: 'OTROS' },
  { value: 1350, label: 'RETENCION SOBRE CONTRATOS' },
  { value: 135005, label: 'DE CONSTRUCCION' },
  { value: 135010, label: 'DE PRESTACION DE SERVICIOS' },
  { value: 135095, label: 'OTROS' },
  { value: 1355, label: 'ANTICIPO DE IMPUESTOS Y CONTRIBUCIONES O SALDOS A FAVOR' },
  { value: 135505, label: 'ANTICIPO DE IMPUESTOS DE RENTA Y COMPLEMENTARIOS' },
  { value: 135510, label: 'ANTICIPO DE IMPUESTOS DE INDUSTRIA Y COMERCIO' },
  { value: 135515, label: 'RETENCION EN LA FUENTE' },
  { value: 135520, label: 'SOBRANTES EN LIQUIDACION PRIVADA DE IMPUESTOS' },
  { value: 135525, label: 'CONTRIBUCIONES' },
  { value: 135530, label: 'IMPUESTOS DESCONTABLES' },
  { value: 135595, label: 'OTROS' },
  { value: 1360, label: 'RECLAMACIONES' },
  { value: 136005, label: 'A COMPAÑIAS ASEGURADORAS' },
  { value: 136010, label: 'A TRANSPORTADORES' },
  { value: 136015, label: 'POR TIQUETES AEREOS' },
  { value: 136095, label: 'OTRAS' },
  { value: 1365, label: 'CUENTAS POR COBRAR A TRABAJADORES' },
  { value: 136505, label: 'VIVIENDA' },
  { value: 136510, label: 'VEHICULOS' },
  { value: 136515, label: 'EDUCACION' },
  { value: 136520, label: 'MEDICOS, ODONTOLOGICOS Y SIMILARES' },
  { value: 136525, label: 'CALAMIDAD DOMESTICA' },
  { value: 136530, label: 'RESPONSABILIDADES' },
  { value: 136595, label: 'OTROS' },
  { value: 1370, label: 'PRESTAMOS A PARTICULARES' },
  { value: 137005, label: 'CON GARANTIA REAL' },
  { value: 137010, label: 'CON GARANTIA PERSONAL' },
  { value: 1380, label: 'DEUDORES VARIOS' },
  { value: 138005, label: 'DEPOSITARIOS' },
  { value: 138010, label: 'COMISIONISTAS DE BOLSAS' },
  { value: 138015, label: 'FONDO DE INVERSION' },
  { value: 138020, label: 'CUENTAS POR COBRAR DE TERCEROS' },
  { value: 138025, label: 'PAGOS POR CUENTA DE TERCEROS' },
  { value: 138030, label: 'FONDOS DE INVERSION SOCIAL' },
  { value: 138095, label: 'OTROS' },
  { value: 1385, label: 'DERECHOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: 1390, label: 'DEUDAS DE DIFICIL COBRO' },
  { value: 1399, label: 'PROVISIONES' },
  { value: 139905, label: 'CLIENTES' },
  { value: 139910, label: 'CUENTAS CORRIENTES COMERCIALES' },
  { value: 139915, label: 'CUENTAS POR COBRAR A CASA MATRIZ' },
  { value: 139920, label: 'CUENTAS POR COBRAR A VINCULADOS ECONOMICOS' },
  { value: 139925, label: 'CUENTAS POR COBRAR A SOCIOS Y ACCIONISTAS' },
  { value: 139930, label: 'ANTICIPOS Y AVANCES' },
  { value: 139932, label: 'CUENTAS DE OPERACION CONJUNTA' },
  { value: 139935, label: 'DEPOSITOS' },
  { value: 139940, label: 'PROMESAS DE COMPRAVENTA' },
  { value: 139945, label: 'INGRESOS POR COBRAR' },
  { value: 139950, label: 'RETENCION SOBRE CONTRATOS' },
  { value: 139955, label: 'RECLAMACIONES' },
  { value: 139960, label: 'CUENTAS POR COBRAR A TRABAJADORES' },
  { value: 139965, label: 'PRESTAMOS A PARTICULARES' },
  { value: 139975, label: 'DEUDORES VARIOS' },
  { value: 139980, label: 'DERECHOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: 14, label: 'INVENTARIOS' },
  { value: 1405, label: 'MATERIAS PRIMAS' },
  { value: 140599, label: 'AJUSTES POR INFLACION' },
  { value: 1410, label: 'PRODUCTOS EN PROCESO' },
  { value: 141099, label: 'AJUSTES POR INFLACION' },
  { value: 1415, label: 'OBRAS DE CONSTRUCCION EN CURSO' },
  { value: 141599, label: 'AJUSTES POR INFLACION' },
  { value: 1417, label: 'OBRAS DE URBANISMO' },
  { value: 141799, label: 'AJUSTES POR INFLACION' },
  { value: 1420, label: 'CONTRATOS EN EJECUCION' },
  { value: 142099, label: 'AJUSTES POR INFLACION' },
  { value: 1425, label: 'CULTIVOS EN DESARROLLO' },
  { value: 142599, label: 'AJUSTES POR INFLACION' },
  { value: 1430, label: 'PRODUCTOS TERMINADOS' },
  { value: 143005, label: 'PRODUCTOS MANUFACTURADOS' },
  { value: 143010, label: 'PRODUCTOS EXTRAIDOS Y/O PROCESADOS' },
  { value: 143015, label: 'PRODUCTOS AGRICOLAS Y FORESTALES' },
  { value: 143020, label: 'SUBPRODUCTOS' },
  { value: 143025, label: 'PRODUCTOS DE PESCA' },
  { value: 143099, label: 'AJUSTES POR INFLACION' },
  { value: 1435, label: 'MERCANCIAS NO FABRICADAS POR LA EMPRESA' },
  { value: 143599, label: 'AJUSTES POR INFLACION' },
  { value: 1440, label: 'BIENES RAICES PARA LA VENTA' },
  { value: 144099, label: 'AJUSTES POR INFLACION' },
  { value: 1445, label: 'SEMOVIENTES' },
  { value: 144505, label: 'ESPECIES MAYORES' },
  { value: 144510, label: 'ESPECIES MENORES' },
  { value: 144599, label: 'AJUSTES POR INFLACION' },
  { value: 1450, label: 'TERRENOS' },
  { value: 145005, label: 'POR URBANIZAR' },
  { value: 145010, label: 'URBANIZADOS POR CONSTRUIR' },
  { value: 145099, label: 'AJUSTES POR INFLACION' },
  { value: 1455, label: 'MATERIALES, REPUESTOS Y ACCESORIOS' },
  { value: 145505, label: 'COMBUSTIBLES Y LUBRICANTES' },
  { value: 145510, label: 'ABONOS Y FERTILIZANTES' },
  { value: 145515, label: 'SEMILLAS TERMINADAS' },
  { value: 145520, label: 'FUNGICIDAS Y HERBICIDAS' },
  { value: 145525, label: 'MATERIALES Y REPUESTOS' },
  { value: 145530, label: 'LOZA Y CRISTALERIA' },
  { value: 145535, label: 'HERRAMIENTAS' },
  { value: 145540, label: 'MEDICINAS' },
  { value: 145545, label: 'ELEMENTOS HOSPITALARIOS' },
  { value: 145550, label: 'INSTRUMENTAL QUIRURGICO' },
  { value: 145555, label: 'DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: 145560, label: 'ELEMENTOS DE ROPERIA Y LENCERIA' },
  { value: 145595, label: 'OTROS' },
  { value: 145599, label: 'AJUSTES POR INFLACION' },
  { value: 1460, label: 'ENVASES Y EMPAQUES' },
  { value: 146099, label: 'AJUSTES POR INFLACION' },
  { value: 1465, label: 'INVENTARIOS EN TRANSITO' },
  { value: 146599, label: 'AJUSTES POR INFLACION' },
  { value: 1499, label: 'PROVISIONES' },
  { value: 149905, label: 'PARA OBSOLESCENCIA' },
  { value: 149910, label: 'PARA DIFERENCIA DE INVENTARIO FISICO' },
  { value: 149915, label: 'PARA PERDIDAS DE INVENTARIOS' },
  { value: 149920, label: 'LIFO' },
  { value: 15, label: 'PROPIEDADES PLANTA Y EQUIPO' },
  { value: 1504, label: 'TERRENOS' },
  { value: 150405, label: 'URBANOS' },
  { value: 150410, label: 'RURALES' },
  { value: 150499, label: 'AJUSTES POR INFLACION' },
  { value: 1506, label: 'MATERIALES PROYECTOS PETROLEROS' },
  { value: 150605, label: 'TUBERIAS Y EQUIPO' },
  { value: 150610, label: 'COSTOS DE IMPORTACION MATERIALES' },
  { value: 150615, label: 'PROYECTOS DE CONSTRUCCION' },
  { value: 150699, label: 'AJUSTES POR INFLACION' },
  { value: 1508, label: 'CONSTRUCCIONES EN CURSO' },
  { value: 150805, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 150810, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 150815, label: 'VIAS DE COMUNICACION' },
  { value: 150820, label: 'POZOS ARTESIANOS' },
  { value: 150825, label: 'PROYECTOS DE EXPLORACION' },
  { value: 150830, label: 'PROYECTOS DE DESARROLLO' },
  { value: 150899, label: 'AJUSTES POR INFLACION' },
  { value: 1512, label: 'MAQUINARIA Y EQUIPOS EN MONTAJE' },
  { value: 151205, label: 'MAQUINARIA Y EQUIPO' },
  { value: 151210, label: 'EQUIPO DE OFICINA' },
  { value: 151215, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 151220, label: 'EQUIPO MEDICO-CIENTIFICO' },
  { value: 151225, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 151230, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 151235, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 151240, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 151245, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 151250, label: 'PLANTAS Y REDES' },
  { value: 151299, label: 'AJUSTES POR INFLACION' },
  { value: 1516, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 151605, label: 'EDIFICIOS' },
  { value: 151610, label: 'OFICINAS' },
  { value: 151615, label: 'ALMACENES' },
  { value: 151620, label: 'FABRICAS Y PLANTAS INDUSTRIALES' },
  { value: 151625, label: 'SALAS DE EXHIBICION Y VENTAS' },
  { value: 151630, label: 'CAFETERIA Y CASINOS' },
  { value: 151635, label: 'SILOS' },
  { value: 151640, label: 'INVERNADEROS' },
  { value: 151645, label: 'CASETAS Y CAMPAMENTOS' },
  { value: 151650, label: 'INSTALACIONES AGROPECUARIAS' },
  { value: 151655, label: 'VIVIENDAS PARA EMPLEADOS Y OBREROS' },
  { value: 151660, label: 'TERMINAL DE BUSES Y TAXIS' },
  { value: 151663, label: 'TERMINAL MARITIMO' },
  { value: 151665, label: 'TERMINAL FERREO' },
  { value: 151670, label: 'PARQUEADEROS, GARAJES Y DEPOSITOS' },
  { value: 151675, label: 'HANGARES' },
  { value: 151680, label: 'BODEGAS' },
  { value: 151695, label: 'OTROS' },
  { value: 151699, label: 'AJUSTES POR INFLACION' },
  { value: 1520, label: 'MAQUINARIA Y EQUIPO' },
  { value: 152099, label: 'AJUSTES POR INFLACION' },
  { value: 1524, label: 'EQUIPO DE OFICINA' },
  { value: 152405, label: 'MUEBLES Y ENSERES' },
  { value: 152410, label: 'EQUIPOS' },
  { value: 152495, label: 'OTROS' },
  { value: 152499, label: 'AJUSTES POR INFLACION' },
  { value: 1528, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 152805, label: 'EQUIPOS DE PROCESAMIENTO DE DATOS' },
  { value: 152810, label: 'EQUIPOS DE TELECOMUNICACIONES' },
  { value: 152815, label: 'EQUIPOS DE RADIO' },
  { value: 152820, label: 'SATELITES Y ANTENAS' },
  { value: 152825, label: 'LINEAS TELEFONICAS' },
  { value: 152895, label: 'OTROS' },
  { value: 152899, label: 'AJUSTES POR INFLACION' },
  { value: 1532, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 153205, label: 'MEDICO' },
  { value: 153210, label: 'ODONTOLOGICO' },
  { value: 153215, label: 'LABORATORIO' },
  { value: 153220, label: 'INSTRUMENTAL' },
  { value: 153295, label: 'OTROS' },
  { value: 153299, label: 'AJUSTES POR INFLACION' },
  { value: 1536, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 153605, label: 'DE HABITACIONES' },
  { value: 153610, label: 'DE COMESTIBLES Y BEBIDAS' },
  { value: 153695, label: 'OTROS' },
  { value: 153699, label: 'AJUSTES POR INFLACION' },
  { value: 1540, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 154005, label: 'AUTOS, CAMIONETAS Y CAMPEROS' },
  { value: 154008, label: 'CAMIONES, VOLQUETAS Y FURGONES' },
  { value: 154010, label: 'TRACTOMULAS Y REMOLQUES' },
  { value: 154015, label: 'BUSES Y BUSETAS' },
  { value: 154017, label: 'RECOLECTORES Y CONTENEDORES' },
  { value: 154020, label: 'MONTACARGAS' },
  { value: 154025, label: 'PALAS Y GRUAS' },
  { value: 154030, label: 'MOTOCICLETAS' },
  { value: 154035, label: 'BICICLETAS' },
  { value: 154040, label: 'ESTIBAS Y CARRETAS' },
  { value: 154045, label: 'BANDAS TRANSPORTADORAS' },
  { value: 154095, label: 'OTROS' },
  { value: 154099, label: 'AJUSTES POR INFLACION' },
  { value: 1544, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 154405, label: 'BUQUES' },
  { value: 154410, label: 'LANCHAS' },
  { value: 154415, label: 'REMOLCADORAS' },
  { value: 154420, label: 'BOTES' },
  { value: 154425, label: 'BOYAS' },
  { value: 154430, label: 'AMARRES' },
  { value: 154435, label: 'CONTENEDORES Y CHASSISES' },
  { value: 154440, label: 'GABARRAS' },
  { value: 154495, label: 'OTROS' },
  { value: 154499, label: 'AJUSTES POR INFLACION' },
  { value: 1548, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 154805, label: 'AVIONES' },
  { value: 154810, label: 'AVIONETAS' },
  { value: 154815, label: 'HELICOPTEROS' },
  { value: 154820, label: 'TURBINAS Y MOTORES' },
  { value: 154825, label: 'MANUALES DE ENTRENAMIENTO PERSONAL TECNICO' },
  { value: 154830, label: 'EQUIPOS DE VUELO' },
  { value: 154895, label: 'OTROS' },
  { value: 154899, label: 'AJUSTES POR INFLACION' },
  { value: 1552, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 155205, label: 'LOCOMOTORAS' },
  { value: 155210, label: 'VAGONES' },
  { value: 155215, label: 'REDES FERREAS' },
  { value: 155295, label: 'OTROS' },
  { value: 155299, label: 'AJUSTES POR INFLACION' },
  { value: 1556, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 155605, label: 'INSTALACIONES PARA AGUA Y ENERGIA' },
  { value: 155610, label: 'ACUEDUCTO ACEQUIAS Y CANALIZACIONES' },
  { value: 155615, label: 'PLANTAS DE GENERACION HIDRAULICA' },
  { value: 155620, label: 'PLANTAS DE GENERACION TERMICA' },
  { value: 155625, label: 'PLANTAS DE GENERACION A GAS' },
  { value: 155628, label: 'PLANTAS DE GENERACION DIESEL, GASOLINA Y PETROLEO' },
  { value: 155630, label: 'PLANTAS DE DISTRIBUCION' },
  { value: 155635, label: 'PLANTAS DE TRANSMISION Y SUBESTACIONES' },
  { value: 155640, label: 'OLEODUCTOS' },
  { value: 155645, label: 'GASODUCTOS' },
  { value: 155647, label: 'POLIDUCTOS' },
  { value: 155650, label: 'REDES DE DISTRIBUCION' },
  { value: 155655, label: 'PLANTAS DE TRATAMIENTO' },
  { value: 155660, label: 'REDES DE RECOLECCION DE AGUAS NEGRAS' },
  { value: 155665, label: 'INSTALACIONES Y EQUIPO DE BOMBEO' },
  { value: 155670, label: 'REDES DE DISTRIBUCION DE VAPOR' },
  { value: 155675, label: 'REDES DE AIRE' },
  { value: 155680, label: 'REDES ALIMENTACION DE GAS' },
  { value: 155682, label: 'REDES EXTERNAS DE TELEFONIA' },
  { value: 155685, label: 'PLANTAS DESHIDRATADORAS' },
  { value: 155695, label: 'OTROS' },
  { value: 155699, label: 'AJUSTES POR INFLACION' },
  { value: 1560, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 156099, label: 'AJUSTES POR INFLACION' },
  { value: 1562, label: 'ENVASES Y EMPAQUES' },
  { value: 156299, label: 'AJUSTES POR INFLACION' },
  { value: 1564, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 156405, label: 'CULTIVOS EN DESARROLLO' },
  { value: 156410, label: 'CULTIVOS AMORTIZABLES' },
  { value: 156499, label: 'AJUSTES POR INFLACION' },
  { value: 1568, label: 'VIAS DE COMUNICACION' },
  { value: 156805, label: 'PAVIMENTACION Y PATIOS' },
  { value: 156810, label: 'VIAS' },
  { value: 156815, label: 'PUENTES' },
  { value: 156820, label: 'CALLES' },
  { value: 156825, label: 'AERODROMOS' },
  { value: 156895, label: 'OTROS' },
  { value: 156899, label: 'AJUSTES POR INFLACION' },
  { value: 1572, label: 'MINAS Y CANTERAS' },
  { value: 157205, label: 'MINAS' },
  { value: 157210, label: 'CANTERAS' },
  { value: 157299, label: 'AJUSTES POR INFLACION' },
  { value: 1576, label: 'POZOS ARTESIANOS' },
  { value: 157699, label: 'AJUSTES POR INFLACION' },
  { value: 1580, label: 'YACIMIENTOS' },
  { value: 158099, label: 'AJUSTES POR INFLACION' },
  { value: 1584, label: 'SEMOVIENTES' },
  { value: 158405, label: 'ESPECIES MENORES' },
  { value: 158410, label: 'ESPECIES MAYORES' },
  { value: 158499, label: 'AJUSTES POR INFLACION' },
  { value: 1588, label: 'PROPIEDADES PLANTA Y EQUIPO EN TRANSITO' },
  { value: 158805, label: 'MAQUINARIA Y EQUIPO' },
  { value: 158810, label: 'EQUIPO DE OFICINA' },
  { value: 158815, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 158820, label: 'EQUIPO MEDICO CIENTIFICO' },
  { value: 158825, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 158830, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 158835, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 158840, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 158845, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 158850, label: 'PLANTAS Y REDES' },
  { value: 158855, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 158860, label: 'SEMOVIENTES' },
  { value: 158865, label: 'ENVASES Y EMPAQUES' },
  { value: 158899, label: 'AJUSTES POR INFLACION' },
  { value: 1592, label: 'DEPRECIACION ACUMULADA' },
  { value: 159205, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 159210, label: 'MAQUINARIA Y EQUIPO' },
  { value: 159215, label: 'EQUIPO DE OFICINA' },
  { value: 159220, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 159225, label: 'EQUIPO MEDICO CIENTIFICO' },
  { value: 159230, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 159235, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 159240, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 159245, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 159250, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 159255, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 159260, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 159265, label: 'ENVASES Y EMPAQUES' },
  { value: 159299, label: 'AJUSTES POR INFLACION' },
  { value: 1596, label: 'DEPRECIACION DIFERIDA' },
  { value: 159605, label: 'EXCESO FISCAL SOBRE LA CONTABLE' },
  { value: 159610, label: 'DEFECTO FISCAL SOBRE LA CONTABLE (CR)' },
  { value: 159699, label: 'AJUSTES POR INFLACION' },
  { value: 1597, label: 'AMORTIZACION ACUMULADA' },
  { value: 159705, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 159710, label: 'VIAS DE COMUNICACION' },
  { value: 159715, label: 'SEMOVIENTES' },
  { value: 159799, label: 'AJUSTES POR INFLACION' },
  { value: 1598, label: 'AGOTAMIENTO ACUMULADO' },
  { value: 159805, label: 'MINAS Y CANTERAS' },
  { value: 159815, label: 'POZOS ARTESIANOS' },
  { value: 159820, label: 'YACIMIENTOS' },
  { value: 159899, label: 'AJUSTES POR INFLACION' },
  { value: 1599, label: 'PROVISIONES' },
  { value: 159904, label: 'TERRENOS' },
  { value: 159906, label: 'MATERIALES PROYECTOS PETROLEROS' },
  { value: 159908, label: 'CONSTRUCCIONES EN CURSO' },
  { value: 159912, label: 'MAQUINARIA EN MONTAJE' },
  { value: 159916, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 159920, label: 'MAQUINARIA Y EQUIPO' },
  { value: 159924, label: 'EQUIPO DE OFICINA' },
  { value: 159928, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 159932, label: 'EQUIPO MEDICO CIENTIFICO' },
  { value: 159936, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 159940, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 159944, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 159948, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 159952, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 159956, label: 'ACUEDUCTOS, PLANTAS Y REDES' },
  { value: 159960, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 159962, label: 'ENVASES Y EMPAQUES' },
  { value: 159964, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 159968, label: 'VIAS DE COMUNICACION' },
  { value: 159972, label: 'MINAS Y CANTERAS' },
  { value: 159980, label: 'POZOS ARTESIANOS' },
  { value: 159984, label: 'YACIMIENTOS' },
  { value: 159988, label: 'SEMOVIENTES' },
  { value: 159992, label: 'PROPIEDADES PLANTA Y EQUIPO EN TRANSITO' },
  { value: 16, label: 'INTANGIBLES' },
  { value: 1605, label: 'CREDITO MERCANTIL' },
  { value: 160505, label: 'FORMADO O ESTIMADO' },
  { value: 160510, label: 'ADQUIRIDO O COMPRADO' },
  { value: 160599, label: 'AJUSTES POR INFLACION' },
  { value: 1610, label: 'MARCAS' },
  { value: 161005, label: 'ADQUIRIDAS' },
  { value: 161010, label: 'FORMADAS' },
  { value: 161099, label: 'AJUSTES POR INFLACION' },
  { value: 1615, label: 'PATENTES' },
  { value: 161505, label: 'ADQUIRIDAS' },
  { value: 161510, label: 'FORMADAS' },
  { value: 161599, label: 'AJUSTES POR INFLACION' },
  { value: 1620, label: 'CONCESIONES Y FRANQUICIAS' },
  { value: 162005, label: 'CONCESIONES' },
  { value: 162010, label: 'FRANQUICIAS' },
  { value: 162099, label: 'AJUSTES POR INFLACION' },
  { value: 1625, label: 'DERECHOS' },
  { value: 162505, label: 'DERECHOS DE AUTOR' },
  { value: 162510, label: 'PUESTO DE BOLSA' },
  { value: 162515, label: 'EN FIDEICOMISOS INMOBILIARIOS' },
  { value: 162520, label: 'EN FIDEICOMISOS DE GARANTIA' },
  { value: 162525, label: 'EN FIDEICOMISOS DE ADMINISTRACION' },
  { value: 162595, label: 'OTROS' },
  { value: 162599, label: 'AJUSTES POR INFLACION' },
  { value: 1630, label: 'KNOW HOW' },
  { value: 163099, label: 'AJUSTES POR INFLACION' },
  { value: 1635, label: 'LICENCIAS' },
  { value: 163599, label: 'AJUSTES POR INFLACION' },
  { value: 1698, label: 'AMORTIZACION ACUMULADA' },
  { value: 169805, label: 'CREDITO MERCANTIL' },
  { value: 169810, label: 'MARCAS' },
  { value: 169815, label: 'PATENTES' },
  { value: 169820, label: 'CONCESIONES Y FRANQUICIAS' },
  { value: 169830, label: 'DERECHOS' },
  { value: 169835, label: 'KNOW HOW' },
  { value: 169840, label: 'LICENCIAS' },
  { value: 169899, label: 'AJUSTES POR INFLACION' },
  { value: 1699, label: 'PROVISIONES' },
  { value: 17, label: 'DIFERIDOS' },
  { value: 1705, label: 'GASTOS PAGADOS POR ANTICIPADO' },
  { value: 170505, label: 'INTERESES' },
  { value: 170510, label: 'HONORARIOS' },
  { value: 170515, label: 'COMISIONES' },
  { value: 170520, label: 'SEGUROS Y FIANZAS' },
  { value: 170525, label: 'ARRENDAMIENTOS' },
  { value: 170530, label: 'BODEGAJES' },
  { value: 170535, label: 'MANTENIMIENTO EQUIPOS' },
  { value: 170540, label: 'SERVICIOS' },
  { value: 170545, label: 'SUSCRIPCIONES' },
  { value: 170595, label: 'OTROS' },
  { value: 1710, label: 'CARGOS DIFERIDOS' },
  { value: 171004, label: 'ORGANIZACION Y PREOPERATIVOS' },
  { value: 171008, label: 'REMODELACIONES' },
  { value: 171012, label: 'ESTUDIOS, INVESTIGACIONES Y PROYECTOS' },
  { value: 171016, label: 'PROGRAMAS PARA COMPUTADOR (SOFTWARE)' },
  { value: 171020, label: 'UTILES Y PAPELERIA' },
  { value: 171024, label: 'MEJORAS A PROPIEDADES AJENAS' },
  { value: 171028, label: 'CONTRIBUCIONES Y AFILIACIONES' },
  { value: 171032, label: 'ENTRENAMIENTO DE PERSONAL' },
  { value: 171036, label: 'FERIAS Y EXPOSICIONES' },
  { value: 171040, label: 'LICENCIAS' },
  { value: 171044, label: 'PUBLICIDAD, PROPAGANDA Y AVISOS' },
  { value: 171048, label: 'ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: 171052, label: 'MOLDES Y TROQUELES' },
  { value: 171056, label: 'INSTRUMENTAL QUIRURGICO' },
  { value: 171060, label: 'DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: 171064, label: 'ELEMENTOS DE ROPERIA Y LENCERIA' },
  { value: 171068, label: 'LOZA Y CRISTALERIA' },
  { value: 171072, label: 'DESCUENTO EN COLOCACION DE BONOS' },
  { value: 171076, label: 'IMPUESTO DE RENTA DIFERIDO "DEBITOS" POR DIFERENCIAS' },
  { value: 171080, label: 'CONCURSOS Y LICITACIONES' },
  { value: 171095, label: 'OTROS' },
  { value: 171099, label: 'AJUSTES POR INFLACION' },
  { value: 1715, label: 'COSTOS DE EXPLORACION POR AMORTIZAR' },
  { value: 171505, label: 'POZOS SECOS' },
  { value: 171510, label: 'POZOS NO COMERCIALES' },
  { value: 171515, label: 'OTROS COSTOS DE EXPLORACION' },
  { value: 171599, label: 'AJUSTES POR INFLACION' },
  { value: 1720, label: 'COSTOS DE EXPLOTACION Y DESARROLLO' },
  { value: 172005, label: 'PERFORACION Y EXPLOTACION' },
  { value: 172010, label: 'PERFORACIONES CAMPOS EN DESARROLLO' },
  { value: 172015, label: 'FACILIDADES DE PRODUCCION' },
  { value: 172020, label: 'SERVICIO A POZOS' },
  { value: 172099, label: 'AJUSTES POR INFLACION' },
  { value: 1730, label: 'CARGOS POR CORRECCION MONETARIA DIFERIDA' },
  { value: 1798, label: 'AMORTIZACION ACUMULADA' },
  { value: 179805, label: 'COSTOS DE EXPLORACION POR AMORTIZAR' },
  { value: 179810, label: 'COSTOS DE EXPLOTACION Y DESARROLLO' },
  { value: 179899, label: 'AJUSTES POR INFLACION' },
  { value: 18, label: 'OTROS ACTIVOS' },
  { value: 1805, label: 'BIENES DE ARTE Y CULTURA' },
  { value: 180505, label: 'OBRAS DE ARTE' },
  { value: 180510, label: 'BIBLIOTECAS' },
  { value: 180595, label: 'OTROS' },
  { value: 180599, label: 'AJUSTES POR INFLACION' },
  { value: 1895, label: 'DIVERSOS' },
  { value: 189505, label: 'MAQUINAS PORTEADORAS' },
  { value: 189510, label: 'BIENES ENTREGADOS EN COMODATO' },
  { value: 189515, label: 'AMORTIZACION ACUMULADA DE BIENES ENTREGADOS EN COMODATO (CR)' },
  { value: 189520, label: 'BIENES RECIBIDOS EN PAGO' },
  { value: 189525, label: 'DERECHOS SUCESORALES' },
  { value: 189530, label: 'ESTAMPILLAS' },
  { value: 189595, label: 'OTROS' },
  { value: 189599, label: 'AJUSTES POR INFLACION' },
  { value: 1899, label: 'PROVISIONES' },
  { value: 189905, label: 'BIENES DE ARTE Y CULTURA' },
  { value: 189995, label: 'DIVERSOS' },
  { value: 19, label: 'VALORIZACIONES' },
  { value: 1905, label: 'DE INVERSIONES' },
  { value: 190505, label: 'ACCIONES' },
  { value: 190510, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 190515, label: 'DERECHOS FIDUCIARIOS' },
  { value: 1910, label: 'DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 191004, label: 'TERRENOS' },
  { value: 191006, label: 'MATERIALES PROYECTOS PETROLEROS' },
  { value: 191008, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 191012, label: 'MAQUINARIA Y EQUIPO' },
  { value: 191016, label: 'EQUIPO DE OFICINA' },
  { value: 191020, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 191024, label: 'EQUIPO MEDICO CIENTIFICO' },
  { value: 191028, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 191032, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 191036, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 191040, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 191044, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 191048, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 191052, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 191056, label: 'ENVASES Y EMPAQUES' },
  { value: 191060, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 191064, label: 'VIAS DE COMUNICACION' },
  { value: 191068, label: 'MINAS Y CANTERAS' },
  { value: 191072, label: 'POZOS ARTESIANOS' },
  { value: 191076, label: 'YACIMIENTOS' },
  { value: 191080, label: 'SEMOVIENTES' },
  { value: 1995, label: 'DE OTROS ACTIVOS' },
  { value: 199505, label: 'BIENES DE ARTE Y CULTURA' },
  { value: 199510, label: 'BIENES ENTREGADOS EN COMODATO' },
  { value: 199515, label: 'BIENES RECIBIDOS EN PAGO' },
  { value: 199520, label: 'INVENTARIO DE SEMOVIENTES' },
  { value: 2, label: 'PASIVO' },
  { value: 21, label: 'OBLIGACIONES FINANCIERAS' },
  { value: 2105, label: 'BANCOS NACIONALES' },
  { value: 210505, label: 'SOBREGIROS' },
  { value: 210510, label: 'PAGARES' },
  { value: 210515, label: 'CARTAS DE CREDITO' },
  { value: 210520, label: 'ACEPTACIONES BANCARIAS' },
  { value: 2110, label: 'BANCOS DEL EXTERIOR' },
  { value: 211005, label: 'SOBREGIROS' },
  { value: 211010, label: 'PAGARES' },
  { value: 211015, label: 'CARTAS DE CREDITO' },
  { value: 211020, label: 'ACEPTACIONES BANCARIAS' },
  { value: 2115, label: 'CORPORACIONES FINANCIERAS' },
  { value: 211505, label: 'PAGARES' },
  { value: 211510, label: 'ACEPTACIONES FINANCIERAS' },
  { value: 211515, label: 'CARTAS DE CREDITO' },
  { value: 2120, label: 'COMPAÑIAS DE FINANCIAMIENTO COMERCIAL' },
  { value: 212005, label: 'PAGARES' },
  { value: 212010, label: 'ACEPTACIONES FINANCIERAS' },
  { value: 2125, label: 'CORPORACIONES DE AHORRO Y VIVIENDA' },
  { value: 212505, label: 'SOBREGIROS' },
  { value: 212510, label: 'PAGARES' },
  { value: 212515, label: 'HIPOTECARIAS' },
  { value: 2130, label: 'ENTIDADES FINANCIERAS DEL EXTERIOR' },
  { value: 2135, label: 'COMPROMISOS DE RECOMPRA DE INVERSIONES NEGOCIADAS' },
  { value: 213505, label: 'ACCIONES' },
  { value: 213510, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 213515, label: 'BONOS' },
  { value: 213520, label: 'CEDULAS' },
  { value: 213525, label: 'CERTIFICADOS' },
  { value: 213530, label: 'PAPELES COMERCIALES' },
  { value: 213535, label: 'TITULOS' },
  { value: 213540, label: 'ACEPTACIONES BANCARIAS O FINANCIERAS' },
  { value: 213595, label: 'OTROS' },
  { value: 2140, label: 'COMPROMISOS DE RECOMPRA DE CARTERA NEGOCIADA' },
  { value: 2145, label: 'OBLIGACIONES GUBERNAMENTALES' },
  { value: 214505, label: 'GOBIERNO NACIONAL' },
  { value: 214510, label: 'ENTIDADES OFICIALES' },
  { value: 2195, label: 'OTRAS OBLIGACIONES' },
  { value: 219505, label: 'PARTICULARES' },
  { value: 219510, label: 'COMPAÑIAS VINCULADAS' },
  { value: 219515, label: 'CASA MATRIZ' },
  { value: 219520, label: 'SOCIOS O ACCIONISTAS' },
  { value: 219525, label: 'FONDOS Y COOPERATIVAS' },
  { value: 219595, label: 'OTRAS' },
  { value: 22, label: 'PROVEEDORES' },
  { value: 2205, label: 'NACIONALES' },
  { value: 2210, label: 'DEL EXTERIOR' },
  { value: 2215, label: 'CUENTAS CORRIENTES COMERCIALES' },
  { value: 2220, label: 'CASA MATRIZ' },
  { value: 2225, label: 'COMPAÑIAS VINCULADAS' },
  { value: 23, label: 'CUENTAS POR PAGAR' },
  { value: 2305, label: 'CUENTAS CORRIENTES COMERCIALES' },
  { value: 2310, label: 'A CASA MATRIZ' },
  { value: 2315, label: 'A COMPAÑIAS VINCULADAS' },
  { value: 2320, label: 'A CONTRATISTAS' },
  { value: 2330, label: 'ORDENES DE COMPRA POR UTILIZAR' },
  { value: 2335, label: 'COSTOS Y GASTOS POR  PAGAR' },
  { value: 233505, label: 'GASTOS FINANCIEROS' },
  { value: 233510, label: 'GASTOS LEGALES' },
  { value: 233515, label: 'LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: 233520, label: 'COMISIONES' },
  { value: 233525, label: 'HONORARIOS' },
  { value: 233530, label: 'SERVICIOS TECNICOS' },
  { value: 233535, label: 'SERVICIOS DE MANTENIMIENTO' },
  { value: 233540, label: 'ARRENDAMIENTOS' },
  { value: 233545, label: 'TRANSPORTES, FLETES Y ACARREOS' },
  { value: 233550, label: 'SERVICIOS PUBLICOS' },
  { value: 233555, label: 'SEGUROS' },
  { value: 233560, label: 'GASTOS DE VIAJE' },
  { value: 233565, label: 'GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: 233570, label: 'SERVICIOS ADUANEROS' },
  { value: 233595, label: 'OTROS' },
  { value: 2340, label: 'INSTALAMENTOS POR PAGAR' },
  { value: 2345, label: 'ACREEDORES OFICIALES' },
  { value: 2350, label: 'REGALIAS POR PAGAR' },
  { value: 2355, label: 'DEUDAS CON ACCIONISTAS O SOCIOS' },
  { value: 235505, label: 'ACCIONISTAS' },
  { value: 235510, label: 'SOCIOS' },
  { value: 2360, label: 'DIVIDENDOS O PARTICIPACIONES POR PAGAR' },
  { value: 236005, label: 'DIVIDENDOS' },
  { value: 236010, label: 'PARTICIPACIONES' },
  { value: 2365, label: 'RETENCION EN LA FUENTE' },
  { value: 236505, label: 'SALARIOS Y PAGOS LABORALES' },
  { value: 236510, label: 'DIVIDENDOS Y/O PARTICIPACIONES' },
  { value: 236515, label: 'HONORARIOS' },
  { value: 236520, label: 'COMISIONES' },
  { value: 236525, label: 'SERVICIOS' },
  { value: 236530, label: 'ARRENDAMIENTOS' },
  { value: 236535, label: 'RENDIMIENTOS FINANCIEROS' },
  { value: 236540, label: 'COMPRAS' },
  //{ value: 236545, label: 'LOTERIAS, RIFAS, APUESTAS Y SIMILARES' },
  { value: 236550, label: 'POR PAGOS AL EXTERIOR' },
  { value: 236555, label: 'POR INGRESOS OBTENIDOS EN EL EXTERIOR' },
  { value: 236560, label: 'ENAJENACION PROPIEDADES PLANTA Y EQUIPO PERSONAS NATURALES' },
  { value: 236565, label: 'POR IMPUESTO DE TIMBRE' },
  { value: 236570, label: 'OTRAS RETENCIONES Y PATRIMONIO' },
  { value: 236575, label: 'AUTORRETENCIONES' },
  { value: 2370, label: 'RETENCIONES Y APORTES DE NOMINA' },
  { value: 237005, label: 'APORTES AL I.S.S.' },
  { value: 237010, label: 'APORTES AL I.C.B.F., SENA Y CAJAS DE COMPENSACION' },
  { value: 237015, label: 'APORTES AL F.I.C.' },
  { value: 237025, label: 'EMBARGOS JUDICIALES' },
  { value: 237030, label: 'LIBRANZAS' },
  { value: 237035, label: 'SINDICATOS' },
  { value: 237040, label: 'COOPERATIVAS' },
  { value: 237045, label: 'FONDOS' },
  { value: 237095, label: 'OTROS' },
  { value: 2375, label: 'CUOTAS POR DEVOLVER' },
  { value: 2380, label: 'ACREEDORES VARIOS' },
  { value: 238005, label: 'DEPOSITARIOS' },
  { value: 238010, label: 'COMISIONISTAS DE BOLSAS' },
  { value: 238015, label: 'SOCIEDAD ADMINISTRADORA - FONDOS DE INVERSION' },
  { value: 238020, label: 'REINTEGROS POR PAGAR' },
  { value: 238025, label: 'FONDO DE PERSEVERANCIA' },
  { value: 238030, label: 'FONDOS DE CESANTIAS Y/O PENSIONES' },
  { value: 238035, label: 'DONACIONES ASIGNADAS POR PAGAR' },
  { value: 238095, label: 'OTROS' },
  { value: 24, label: 'IMPUESTOS, GRAVAMENES Y TASAS' },
  { value: 2404, label: 'DE RENTA Y COMPLEMENTARIOS' },
  { value: 240405, label: 'VIGENCIA FISCAL CORRIENTE' },
  { value: 240410, label: 'VIGENCIAS FISCALES ANTERIORES' },
  { value: 2408, label: 'IMPUESTO SOBRE LAS VENTAS POR PAGAR' },
  { value: 2412, label: 'DE INDUSTRIA Y COMERCIO' },
  { value: 241205, label: 'VIGENCIA FISCAL CORRIENTE' },
  { value: 241210, label: 'VIGENCIAS FISCALES ANTERIORES' },
  { value: 2416, label: 'A LA PROPIEDAD RAIZ' },
  { value: 2420, label: 'DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: 2424, label: 'DE VALORIZACION' },
  { value: 242405, label: 'VIGENCIA FISCAL CORRIENTE' },
  { value: 242410, label: 'VIGENCIAS FISCALES ANTERIORES' },
  { value: 2428, label: 'DE TURISMO' },
  { value: 2432, label: 'TASA POR UTILIZACION DE PUERTOS' },
  { value: 2436, label: 'DE VEHICULOS' },
  { value: 243605, label: 'VIGENCIA FISCAL CORRIENTE' },
  { value: 243610, label: 'VIGENCIAS FISCALES ANTERIORES' },
  { value: 2440, label: 'DE ESPECTACULOS PUBLICOS' },
  { value: 2444, label: 'DE HIDROCARBUROS Y MINAS' },
  { value: 244405, label: 'DE HIDROCARBUROS' },
  { value: 244410, label: 'DE MINAS' },
  { value: 2448, label: 'REGALIAS E IMPUESTOS A LA PEQUEÑA Y MEDIANA MINERIA' },
  { value: 2452, label: 'A LAS EXPORTACIONES CAFETERAS' },
  { value: 2456, label: 'A LAS IMPORTACIONES' },
  { value: 2460, label: 'CUOTAS DE FOMENTO' },
  { value: 2464, label: 'DE LICORES, CERVEZAS Y CIGARRILLOS' },
  { value: 246405, label: 'DE LICORES' },
  { value: 246410, label: 'DE CERVEZAS' },
  { value: 246415, label: 'DE CIGARRILLOS' },
  { value: 2468, label: 'AL SACRIFICIO DE GANADO' },
  { value: 2472, label: 'AL AZAR Y JUEGOS' },
  { value: 2495, label: 'OTROS' },
  { value: 25, label: 'OBLIGACIONES LABORALES' },
  { value: 2505, label: 'SALARIOS POR PAGAR' },
  { value: 2510, label: 'CESANTIAS CONSOLIDADAS' },
  { value: 251005, label: 'LEY LABORAL ANTERIOR' },
  { value: 251010, label: 'LEY 50 DE 1990 Y NORMAS POSTERIORES' },
  { value: 2515, label: 'INTERESES SOBRE CESANTIAS' },
  { value: 2520, label: 'PRIMA DE SERVICIOS' },
  { value: 2525, label: 'VACACIONES CONSOLIDADAS' },
  { value: 252501, label: 'a 252598' },
  { value: 2530, label: 'PRESTACIONES EXTRALEGALES' },
  { value: 253005, label: 'PRIMAS' },
  { value: 253010, label: 'AUXILIOS' },
  { value: 253015, label: 'DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: 253020, label: 'BONIFICACIONES' },
  { value: 253025, label: 'SEGUROS' },
  { value: 253095, label: 'OTRAS' },
  { value: 2532, label: 'PENSIONES POR PAGAR' },
  { value: 2535, label: 'CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: 2540, label: 'INDEMNIZACIONES LABORALES' },
  { value: 26, label: 'PASIVOS ESTIMADOS Y PROVISIONES' },
  { value: 2605, label: 'PARA COSTOS Y GASTOS' },
  { value: 260505, label: 'INTERESES' },
  { value: 260510, label: 'COMISIONES' },
  { value: 260515, label: 'HONORARIOS' },
  { value: 260520, label: 'SERVICIOS TECNICOS' },
  { value: 260525, label: 'TRANSPORTES, FLETES Y ACARREOS' },
  { value: 260530, label: 'GASTOS DE VIAJE' },
  { value: 260535, label: 'SERVICIOS PUBLICOS' },
  { value: 260540, label: 'REGALIAS' },
  { value: 260545, label: 'GARANTIAS' },
  { value: 260550, label: 'MATERIALES Y REPUESTOS' },
  { value: 260595, label: 'OTROS' },
  { value: 2610, label: 'PARA OBLIGACIONES LABORALES' },
  { value: 261005, label: 'CESANTIAS' },
  { value: 261010, label: 'INTERESES SOBRE CESANTIAS' },
  { value: 261015, label: 'VACACIONES' },
  { value: 261020, label: 'PRIMA DE SERVICIOS' },
  { value: 261025, label: 'PRESTACIONES EXTRALEGALES' },
  { value: 261030, label: 'VIATICOS' },
  { value: 261095, label: 'OTRAS' },
  { value: 2615, label: 'PARA OBLIGACIONES FISCALES' },
  { value: 261505, label: 'DE RENTA Y COMPLEMENTARIOS' },
  { value: 261510, label: 'DE INDUSTRIA Y COMERCIO' },
  { value: 261515, label: 'TASA POR UTILIZACION DE PUERTOS' },
  { value: 261520, label: 'DE VEHICULOS' },
  { value: 261525, label: 'DE HIDROCARBUROS Y MINAS' },
  { value: 261595, label: 'OTROS' },
  { value: 2620, label: 'PENSIONES DE JUBILACION' },
  { value: 262005, label: 'CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: 262010, label: 'PENSIONES DE JUBILACION POR AMORTIZAR (DB)' },
  { value: 2625, label: 'PARA OBRAS DE URBANISMO' },
  { value: 262505, label: 'ACUEDUCTO Y ALCANTARILLADO' },
  { value: 262510, label: 'ENERGIA ELECTRICA' },
  { value: 262515, label: 'TELEFONOS' },
  { value: 262595, label: 'OTROS' },
  { value: 2630, label: 'PARA MANTENIMIENTO Y REPARACIONES' },
  { value: 263005, label: 'TERRENOS' },
  { value: 263010, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 263015, label: 'MAQUINARIA Y EQUIPO' },
  { value: 263020, label: 'EQUIPO DE OFICINA' },
  { value: 263025, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 263030, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 263035, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 263040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 263045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 263050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 263055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 263060, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 263065, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 263070, label: 'ENVASES Y EMPAQUES' },
  { value: 263075, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 263080, label: 'VIAS DE CUMUNICACION' },
  { value: 263085, label: 'POZOS ARTESIANOS' },
  { value: 263095, label: 'OTROS' },
  { value: 2635, label: 'PARA CONTINGENCIAS' },
  { value: 263505, label: 'MULTAS Y SANCIONES AUTORIDADES ADMINISTRATIVAS' },
  { value: 263510, label: 'INTERESES POR MULTAS Y SANCIONES' },
  { value: 263515, label: 'RECLAMOS' },
  { value: 263520, label: 'LABORALES' },
  { value: 263525, label: 'CIVILES' },
  { value: 263530, label: 'PENALES' },
  { value: 263535, label: 'ADMINISTRATIVOS' },
  { value: 263540, label: 'COMERCIALES' },
  { value: 263595, label: 'OTRAS' },
  { value: 2640, label: 'PARA OBLIGACIONES DE GARANTIAS' },
  { value: 2695, label: 'PROVISIONES DIVERSAS' },
  { value: 269505, label: 'PARA BENEFICENCIA' },
  { value: 269510, label: 'PARA COMUNICACIONES' },
  { value: 269515, label: 'PARA PERDIDA EN TRANSPORTE' },
  { value: 269520, label: 'PARA OPERACION' },
  { value: 269525, label: 'PARA PROTECCION DE BIENES AGOTABLES' },
  { value: 269530, label: 'PARA AJUSTES EN REDENCION DE UNIDADES' },
  { value: 269535, label: 'AUTOSEGURO' },
  { value: 269540, label: 'PLANES Y PROGRAMAS DE REFORESTACION Y ELECTRIFICACION' },
  { value: 269595, label: 'OTRAS' },
  { value: 27, label: 'DIFERIDOS' },
  { value: 2705, label: 'INGRESOS RECIBIDOS POR ANTICIPADO' },
  { value: 270505, label: 'INTERESES' },
  { value: 270510, label: 'COMISIONES' },
  { value: 270515, label: 'ARRENDAMIENTOS' },
  { value: 270520, label: 'HONORARIOS' },
  { value: 270525, label: 'SERVICIOS TECNICOS' },
  { value: 270530, label: 'DE SUSCRIPTORES' },
  { value: 270535, label: 'TRANSPORTES, FLETES Y ACARREOS' },
  { value: 270540, label: 'MERCANCIA EN TRANSITO YA VENDIDA' },
  { value: 270545, label: 'MATRICULAS Y PENSIONES' },
  { value: 270550, label: 'CUOTAS DE ADMINISTRACION' },
  { value: 270595, label: 'OTROS' },
  { value: 2710, label: 'ABONOS DIFERIDOS' },
  { value: 271005, label: 'REAJUSTE DEL SISTEMA' },
  { value: 2715, label: 'UTILIDAD DIFERIDA EN VENTAS A PLAZOS' },
  { value: 2720, label: 'CREDITO POR CORRECCION MONETARIA DIFERIDA' },
  { value: 2725, label: 'IMPUESTOS DIFERIDOS' },
  { value: 272505, label: 'POR DEPRECIACION FLEXIBLE' },
  { value: 272595, label: 'DIVERSOS' },
  { value: 272599, label: 'AJUSTES POR INFLACION' },
  { value: 28, label: 'OTROS PASIVOS' },
  { value: 2805, label: 'ANTICIPOS Y AVANCES RECIBIDOS' },
  { value: 280505, label: 'DE CLIENTES' },
  { value: 280510, label: 'SOBRE CONTRATOS' },
  { value: 280515, label: 'PARA OBRAS EN PROCESO' },
  { value: 280595, label: 'OTROS' },
  { value: 2810, label: 'DEPOSITOS RECIBIDOS' },
  { value: 281005, label: 'PARA FUTURA SUSCRIPCION DE ACCIONES' },
  { value: 281010, label: 'PARA FUTURO PAGO DE CUOTAS O DERECHOS SOCIALES' },
  { value: 281015, label: 'PARA GARANTIA EN LA PRESTACION DE SERVICIOS' },
  { value: 281020, label: 'PARA GARANTIA DE CONTRATOS' },
  { value: 281025, label: 'DE LICITACIONES' },
  { value: 281030, label: 'DE MANEJO DE BIENES' },
  { value: 281035, label: 'FONDO DE RESERVA' },
  { value: 281095, label: 'OTROS' },
  { value: 2815, label: 'INGRESOS RECIBIDOS PARA TERCEROS' },
  { value: 281505, label: 'VALORES RECIBIDOS PARA TERCEROS' },
  { value: 281510, label: 'VENTA POR CUENTA DE TERCEROS' },
  { value: 2820, label: 'CUENTAS DE OPERACION CONJUNTA' },
  { value: 2825, label: 'RETENCIONES A TERCEROS SOBRE CONTRATOS' },
  { value: 282505, label: 'CUMPLIMIENTO OBLIGACIONES LABORALES' },
  { value: 282510, label: 'PARA ESTABILIDAD DE OBRA' },
  { value: 282515, label: 'GARANTIA CUMPLIMIENTO DE CONTRATOS' },
  { value: 2830, label: 'EMBARGOS JUDICIALES' },
  { value: 283005, label: 'INDEMNIZACIONES' },
  { value: 283010, label: 'DEPOSITOS JUDICIALES' },
  { value: 2835, label: 'ACREEDORES DEL SISTEMA' },
  { value: 283505, label: 'CUOTAS NETAS' },
  { value: 283510, label: 'GRUPOS EN FORMACION' },
  { value: 2840, label: 'CUENTAS EN PARTICIPACION' },
  { value: 2895, label: 'DIVERSOS' },
  { value: 289505, label: 'PRESTAMOS DE PRODUCTOS' },
  { value: 289510, label: 'REEMBOLSO DE COSTOS EXPLORATORIOS' },
  { value: 289515, label: 'PROGRAMA DE EXTENSION AGROPECUARIA' },
  { value: 29, label: 'BONOS Y PAPELES COMERCIALES' },
  { value: 2905, label: 'BONOS EN CIRCULACION' },
  { value: 290505, label: 'GARANTIA GENERAL' },
  { value: 290510, label: 'GARANTIA ESPECIFICA' },
  { value: 2910, label: 'BONOS OBLIGATORIAMENTE CONVERTIBLES EN ACCIONES' },
  { value: 2915, label: 'PAPELES COMERCIALES' },
  { value: 3, label: 'PATRIMONIO' },
  { value: 31, label: 'CAPITAL SOCIAL' },
  { value: 3105, label: 'CAPITAL SUSCRITO Y PAGADO' },
  { value: 310505, label: 'CAPITAL AUTORIZADO' },
  { value: 310510, label: 'CAPITAL POR SUSCRIBIR (DB)' },
  { value: 310515, label: 'CAPITAL SUSCRITO POR COBRAR (DB)' },
  { value: 3110, label: 'ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL PROPIAS READQUIRIDAS (DB)' },
  { value: 311005, label: 'ACCIONES PROPIAS READQUIRIDAS (DB)' },
  { value: 311010, label: 'CUOTAS O PARTES DE INTERES SOCIAL PROPIAS READQUIRIDAS (DB)' },
  { value: 3115, label: 'APORTES SOCIALES' },
  { value: 311505, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 311510, label: 'APORTES DE SOCIOS - FONDO MUTUO DE INVERSION' },
  { value: 311515, label: 'CONTRIBUCION DE LA EMPRESA - FONDO MUTUO DE INVERSION' },
  { value: 311520, label: 'SUSCRIPCIONES DEL PUBLICO' },
  { value: 3120, label: 'CAPITAL ASIGNADO' },
  { value: 3125, label: 'INVERSION SUPLEMENTARIA AL CAPITAL ASIGNADO' },
  { value: 3130, label: 'CAPITAL DE PERSONAS NATURALES' },
  { value: 3135, label: 'APORTES DEL ESTADO' },
  { value: 3140, label: 'FONDO SOCIAL' },
  { value: 32, label: 'SUPERAVIT DE CAPITAL' },
  { value: 3205, label: 'PRIMA EN COLOCACION DE ACCIONES, CUOTAS O PARTES DE INTERES' },
  { value: 320505, label: 'PRIMA EN COLOCACION DE ACCIONES' },
  { value: 320510, label: 'PRIMA EN COLOCACION DE ACCIONES POR COBRAR (DB)' },
  { value: 320515, label: 'PRIMA EN COLOCACION DE CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 3210, label: 'DONACIONES' },
  { value: 321005, label: 'EN DINERO' },
  { value: 321010, label: 'EN VALORES MOBILIARIOS' },
  { value: 321015, label: 'EN BIENES MUEBLES' },
  { value: 321020, label: 'EN BIENES INMUEBLES' },
  { value: 321025, label: 'EN INTANGIBLES' },
  { value: 3215, label: 'CREDITO MERCANTIL' },
  { value: 33, label: 'RESERVAS' },
  { value: 3305, label: 'RESERVAS OBLIGATORIAS' },
  { value: 330505, label: 'RESERVA LEGAL' },
  { value: 330510, label: 'RESERVAS POR DISPOSICIONES FISCALES' },
  { value: 330515, label: 'RESERVA PARA READQUISICION DE ACCIONES' },
  { value: 330517, label: 'RESERVA PARA READQUISICION DE CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 330520, label: 'RESERVA PARA EXTENSION AGROPECUARIA' },
  { value: 330525, label: 'RESERVA LEY 7a. DE 1990' },
  { value: 330530, label: 'RESERVA PARA REPOSICION DE SEMOVIENTES' },
  { value: 330535, label: 'RESERVA LEY 4a DE 1980' },
  { value: 330595, label: 'OTRAS' },
  { value: 3310, label: 'RESERVAS ESTATUTARIAS' },
  { value: 331005, label: 'PARA FUTURAS CAPITALIZACIONES' },
  { value: 331010, label: 'PARA REPOSICION DE ACTIVOS' },
  { value: 331015, label: 'PARA FUTUROS ENSANCHES' },
  { value: 331095, label: 'OTRAS' },
  { value: 3315, label: 'RESERVAS OCASIONALES' },
  { value: 331505, label: 'PARA BENEFICENCIA Y CIVISMO' },
  { value: 331510, label: 'PARA FUTURAS CAPITALIZACIONES' },
  { value: 331515, label: 'PARA FUTUROS ENSANCHES' },
  { value: 331520, label: 'PARA ADQUISICION O REPOSICION DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 331525, label: 'PARA INVESTIGACIONES Y DESARROLLO' },
  { value: 331530, label: 'PARA FOMENTO ECONOMICO' },
  { value: 331535, label: 'PARA CAPITAL DE TRABAJO' },
  { value: 331540, label: 'PARA ESTABILIZACION DE RENDIMIENTOS' },
  { value: 331545, label: 'A DISPOSICION DEL MAXIMO ORGANO SOCIAL' },
  { value: 331595, label: 'OTRAS' },
  { value: 34, label: 'REVALORIZACION DEL PATRIMONIO' },
  { value: 3405, label: 'AJUSTES POR INFLACION' },
  { value: 340505, label: 'DE CAPITAL SOCIAL' },
  { value: 340510, label: 'DE SUPERAVIT DE CAPITAL' },
  { value: 340515, label: 'DE RESERVAS' },
  { value: 340520, label: 'DE RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: 340525, label: 'DE ACTIVOS EN PERIODO IMPRODUCTIVO' },
  { value: 3410, label: 'SANEAMIENTO FISCAL' },
  { value: 3415, label: 'AJUSTES POR INFLACION DECRETO 3019 DE 1989' },
  { value: 35, label: 'DIVIDENDOS O PARTICIPACIONES DECRETADOS EN ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 3505, label: 'DIVIDENDOS DECRETADOS EN ACCIONES' },
  { value: 3510, label: 'PARTICIPACIONES DECRETADAS EN CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 36, label: 'RESULTADOS DEL EJERCICIO' },
  { value: 3605, label: 'UTILIDAD DEL EJERCICIO' },
  { value: 360505, label: 'UTILIDAD DEL EJERCICIO' },
  { value: 360510, label: 'UTILIDAD POR EXPOSICION A LA INFLACION' },
  { value: 3610, label: 'PERDIDA DEL EJERCICIO' },
  { value: 361005, label: 'PERDIDA DEL EJERCICIO' },
  { value: 361010, label: 'PERDIDA POR EXPOSICION A LA INFLACION' },
  { value: 37, label: 'RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: 3705, label: 'UTILIDADES O EXCEDENTES ACUMULADOS' },
  { value: 3710, label: 'PERDIDAS ACUMULADAS' },
  { value: 38, label: 'SUPERAVIT POR VALORIZACIONES' },
  { value: 3805, label: 'DE INVERSIONES' },
  { value: 380505, label: 'ACCIONES' },
  { value: 380510, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 380515, label: 'DERECHOS FIDUCIARIOS' },
  { value: 3810, label: 'DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 381004, label: 'TERRENOS' },
  { value: 381006, label: 'MATERIALES PROYECTOS PETROLEROS' },
  { value: 381008, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 381012, label: 'MAQUINARIA Y EQUIPO' },
  { value: 381016, label: 'EQUIPO DE OFICINA' },
  { value: 381020, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 381024, label: 'EQUIPO MEDICO CIENTIFICO' },
  { value: 381028, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 381032, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 381036, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 381040, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 381044, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 381048, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 381052, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 381056, label: 'ENVASES Y EMPAQUES' },
  { value: 381060, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 381064, label: 'VIAS DE COMUNICACION' },
  { value: 381068, label: 'MINAS Y CANTERAS' },
  { value: 381072, label: 'POZOS ARTESIANOS' },
  { value: 381076, label: 'YACIMIENTOS' },
  { value: 381080, label: 'SEMOVIENTES' },
  { value: 3895, label: 'DE OTROS ACTIVOS' },
  { value: 389505, label: 'BIENES DE ARTE Y CULTURA' },
  { value: 389510, label: 'BIENES ENTREGADOS EN COMODATO' },
  { value: 389515, label: 'BIENES RECIBIDOS EN PAGO' },
  { value: 389520, label: 'INVENTARIO DE SEMOVIENTES' },
  { value: 4, label: 'INGRESOS' },
  { value: 41, label: 'OPERACIONALES' },
  { value: 4105, label: 'AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: 410505, label: 'CULTIVO DE CEREALES' },
  { value: 410510, label: 'CULTIVOS DE HORTALIZAS, LEGUMBRES Y PLANTAS ORNAMENTALES' },
  { value: 410515, label: 'CULTIVOS DE FRUTAS, NUECES Y PLANTAS AROMATICAS' },
  { value: 410520, label: 'CULTIVO DE CAFE' },
  { value: 410525, label: 'CULTIVO DE FLORES' },
  { value: 410530, label: 'CULTIVO DE CAÑA DE AZUCAR' },
  { value: 410535, label: 'CULTIVO DE ALGODON Y PLANTAS PARA MATERIAL TEXTIL' },
  { value: 410540, label: 'CULTIVO DE BANANO' },
  { value: 410545, label: 'OTROS CULTIVOS AGRICOLAS' },
  { value: 410550, label: 'CRIA DE OVEJAS, CABRAS, ASNOS, MULAS Y BURDEGANOS' },
  { value: 410555, label: 'CRIA DE GANADO CABALLAR Y VACUNO.' },
  { value: 410560, label: 'PRODUCCION AVICOLA' },
  { value: 410565, label: 'CRIA DE OTROS ANIMALES' },
  { value: 410570, label: 'SERVICIOS AGRICOLAS Y GANADEROS' },
  { value: 410575, label: 'ACTIVIDAD DE CAZA' },
  { value: 410580, label: 'ACTIVIDAD DE SILVICULTURA' },
  { value: 410599, label: 'AJUSTES POR INFLACION' },
  { value: 4110, label: 'PESCA' },
  { value: 411005, label: 'ACTIVIDAD DE PESCA' },
  { value: 411010, label: 'EXPLOTACION DE CRIADEROS DE PECES' },
  { value: 411095, label: 'ACTIVIDADES CONEXAS' },
  { value: 411099, label: 'AJUSTES POR INFLACION' },
  { value: 4115, label: 'EXPLOTACION DE MINAS Y CANTERAS' },
  { value: 411505, label: 'CARBON' },
  { value: 411510, label: 'PETROLEO CRUDO' },
  { value: 411512, label: 'GAS NATURAL' },
  { value: 411514, label: 'SERVICIOS RELACIONADOS CON EXTRACCION DE PETROLEO Y GAS' },
  { value: 411515, label: 'MINERALES DE HIERRO' },
  { value: 411520, label: 'MINERALES METALIFEROS NO FERROSOS' },
  { value: 411525, label: 'PIEDRA, ARENA Y ARCILLA' },
  { value: 411527, label: 'PIEDRAS PRECIOSAS' },
  { value: 411528, label: 'ORO' },
  { value: 411530, label: 'OTRAS MINAS Y CANTERAS' },
  { value: 411532, label: 'PRESTACION DE SERVICIOS SECTOR MINERO' },
  { value: 411595, label: 'ACTIVIDADES CONEXAS' },
  { value: 411599, label: 'AJUSTES POR INFLACION' },
  { value: 4120, label: 'INDUSTRIAS MANUFACTURERAS' },
  { value: 412001, label: 'PRODUCCION Y PROCESAMIENTO DE CARNES Y PRODUCTOS CARNICOS' },
  { value: 412002, label: 'PRODUCTOS DE PESCADO' },
  { value: 412003, label: 'PRODUCTOS DE FRUTAS, LEGUMBRES Y HORTALIZAS' },
  { value: 412004, label: 'ELABORACION DE ACEITES Y GRASAS' },
  { value: 412005, label: 'ELABORACION DE PRODUCTOS LACTEOS' },
  { value: 412006, label: 'ELABORACION DE PRODUCTOS DE MOLINERIA' },
  { value: 412007, label: 'ELABORACION DE ALMIDONES Y DERIVADOS' },
  { value: 412008, label: 'ELABORACION DE ALIMENTOS PARA ANIMALES' },
  { value: 412009, label: 'ELABORACION DE PRODUCTOS PARA PANADERIA' },
  { value: 412010, label: 'ELABORACION DE AZUCAR Y MELAZAS' },
  { value: 412011, label: 'ELABORACION DE CACAO, CHOCOLATE Y CONFITERIA' },
  { value: 412012, label: 'ELABORACION DE PASTAS  Y PRODUCTOS FARINACEOS' },
  { value: 412013, label: 'ELABORACION DE PRODUCTOS DE CAFE' },
  { value: 412014, label: 'ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS' },
  { value: 412015, label: 'ELABORACION DE BEBIDAS ALCOHOLICAS Y ALCOHOL ETILICO' },
  { value: 412016, label: 'ELABORACION DE VINOS' },
  { value: 412017, label: 'ELABORACION DE BEBIDAS MALTEADAS Y DE MALTA' },
  { value: 412018, label: 'ELABORACION DE BEBIDAS NO ALCOHOLICAS' },
  { value: 412019, label: 'ELABORACION DE PRODUCTOS DE TABACO' },
  { value: 412020, label: 'PREPARACION E HILATURA DE FIBRAS TEXTILES Y TEJEDURIA' },
  { value: 412021, label: 'ACABADO DE PRODUCTOS TEXTILES' },
  { value: 412022, label: 'ELABORACION DE ARTICULOS DE MATERIALES TEXTILES' },
  { value: 412023, label: 'ELABORACION DE TAPICES Y ALFOMBRAS' },
  { value: 412024, label: 'ELABORACION DE CUERDAS, CORDELES, BRAMANTES Y REDES' },
  { value: 412025, label: 'ELABORACION DE OTROS PRODUCTOS TEXTILES' },
  { value: 412026, label: 'ELABORACION DE TEJIDOS' },
  { value: 412027, label: 'ELABORACION DE PRENDAS DE VESTIR' },
  { value: 412028, label: 'PREPARACION, ADOBO Y TEÑIDO DE PIELES' },
  { value: 412029, label: 'CURTIDO, ADOBO O PREPARACION DE CUERO' },
  { value: 412030, label: 'ELABORACION DE MALETAS, BOLSOS Y SIMILARES' },
  { value: 412031, label: 'ELABORACION DE CALZADO' },
  { value: 412032, label: 'PRODUCCION DE MADERA, ARTICULOS DE MADERA Y CORCHO' },
  { value: 412033, label: 'ELABORACION DE PASTA Y PRODUCTOS DE MADERA, PAPEL Y CARTON' },
  { value: 412034, label: 'EDICIONES Y PUBLICACIONES' },
  { value: 412035, label: 'IMPRESION' },
  { value: 412036, label: 'SERVICIOS RELACIONADOS CON LA EDICION Y LA IMPRESION' },
  { value: 412037, label: 'REPRODUCCION DE GRABACIONES' },
  { value: 412038, label: 'ELABORACION DE PRODUCTOS DE HORNO DE COQUE' },
  { value: 412039, label: 'ELABORACION DE PRODUCTOS DE LA REFINACION DE PETROLEO' },
  { value: 412040, label: 'ELABORACION DE SUSTANCIAS QUIMICAS BASICAS' },
  { value: 412041, label: 'ELABORACION DE ABONOS Y COMPUESTOS DE NITROGENO' },
  { value: 412042, label: 'ELABORACION DE PLASTICO Y CAUCHO SINTETICO' },
  { value: 412043, label: 'ELABORACION DE PRODUCTOS QUIMICOS DE USO AGROPECUARIO' },
  { value: 412044, label: 'ELABORACION DE PINTURAS, TINTAS Y MASILLAS' },
  { value: 412045, label: 'ELABORACION DE PRODUCTOS FARMACEUTICOS Y BOTANICOS' },
  { value: 412046, label: 'ELABORACION DE JABONES, DETERGENTES Y PREPARADOS DE TOCADOR' },
  { value: 412047, label: 'ELABORACION DE OTROS PRODUCTOS QUIMICOS' },
  { value: 412048, label: 'ELABORACION DE FIBRAS' },
  { value: 412049, label: 'ELABORACION DE OTROS PRODUCTOS DE CAUCHO' },
  { value: 412050, label: 'ELABORACION DE PRODUCTOS DE PLASTICO' },
  { value: 412051, label: 'ELABORACION DE VIDRIO Y PRODUCTOS DE VIDRIO' },
  { value: 412052, label: 'ELABORACION DE PRODUCTOS DE CERAMICA, LOZA, PIEDRA, ARCILLA Y PORCELANA' },
  { value: 412053, label: 'ELABORACION DE CEMENTO, CAL Y YESO' },
  { value: 412054, label: 'ELABORACION DE ARTICULOS DE HORMIGON, CEMENTO Y YESO' },
  { value: 412055, label: 'CORTE, TALLADO Y ACABADO DE LA PIEDRA' },
  { value: 412056, label: 'ELABORACION DE OTROS PRODUCTOS MINERALES NO METALICOS' },
  { value: 412057, label: 'INDUSTRIAS BASICAS Y FUNDICION DE HIERRO Y ACERO' },
  { value: 412058, label: 'PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE METALES NO FERROSOS' },
  { value: 412059, label: 'FUNDICION DE METALES NO FERROSOS' },
  { value: 412060, label: 'FABRICACION DE PRODUCTOS METALICOS PARA USO ESTRUCTURAL' },
  { value: 412061, label: 'FORJA, PRENSADO, ESTAMPADO, LAMINADO DE METAL Y PULVIMETALURGIA' },
  { value: 412062, label: 'REVESTIMIENTO DE METALES Y OBRAS DE INGENIERIA MECANICA' },
  { value: 412063, label: 'FABRICACION DE ARTICULOS DE FERRETERIA' },
  { value: 412064, label: 'ELABORACION DE OTROS PRODUCTOS DE METAL' },
  { value: 412065, label: 'FABRICACION DE MAQUINARIA Y EQUIPO' },
  { value: 412066, label: 'FABRICACION DE EQUIPOS DE ELEVACION Y MANIPULACION' },
  { value: 412067, label: 'ELABORACION DE APARATOS DE USO DOMESTICO' },
  { value: 412068, label: 'ELABORACION DE EQUIPO DE OFICINA' },
  { value: 412069, label: 'ELABORACION DE PILAS Y BATERIAS PRIMARIAS' },
  { value: 412070, label: 'ELABORACION DE EQUIPO DE ILUMINACION' },
  { value: 412071, label: 'ELABORACION DE OTROS TIPOS DE EQUIPO ELECTRICO' },
  { value: 412072, label: 'FABRICACION DE EQUIPOS DE RADIO, TELEVISION Y COMUNICACIONES' },
  { value: 412073, label: 'FABRICACION DE APARATOS E INSTRUMENTOS MEDICOS' },
  { value: 412074, label: 'FABRICACION DE INSTRUMENTOS DE MEDICION Y CONTROL' },
  { value: 412075, label: 'FABRICACION DE INSTRUMENTOS DE OPTICA Y EQUIPO FOTOGRAFICO' },
  { value: 412076, label: 'FABRICACION DE RELOJES' },
  { value: 412077, label: 'FABRICACION DE VEHICULOS AUTOMOTORES' },
  { value: 412078, label: 'FABRICACION DE CARROCERIAS PARA AUTOMOTORES' },
  { value: 412079, label: 'FABRICACION DE PARTES PIEZAS Y ACCESORIOS PARA AUTOMOTORES' },
  { value: 412080, label: 'FABRICACION Y REPARACION DE BUQUES Y OTRAS EMBARCACIONES' },
  { value: 412081, label: 'FABRICACION DE LOCOMOTORAS Y MATERIAL RODANTE PARA FERROCARRILES' },
  { value: 412082, label: 'FABRICACION DE AERONAVES' },
  { value: 412083, label: 'FABRICACION DE MOTOCICLETAS' },
  { value: 412084, label: 'FABRICACION DE BICICLETAS Y SILLAS DE RUEDAS' },
  { value: 412085, label: 'FABRICACION DE OTROS TIPOS DE TRANSPORTE' },
  { value: 412086, label: 'FABRICACION DE MUEBLES' },
  { value: 412087, label: 'FABRICACION DE JOYAS Y ARTICULOS CONEXOS' },
  { value: 412088, label: 'FABRICACION DE INSTRUMENTOS DE MUSICA' },
  { value: 412089, label: 'FABRICACION DE ARTICULOS Y EQUIPO PARA DEPORTE' },
  { value: 412090, label: 'FABRICACION DE JUEGOS Y JUGUETES' },
  { value: 412091, label: 'RECICLAMIENTO DE DESPERDICIOS' },
  { value: 412095, label: 'PRODUCTOS DE OTRAS INDUSTRIAS MANUFACTURERAS' },
  { value: 412099, label: 'AJUSTES POR INFLACION' },
  { value: 4125, label: 'SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: 412505, label: 'GENERACION, CAPTACION Y DISTRIBUCION DE ENERGIA ELECTRICA' },
  { value: 412510, label: 'FABRICACION DE GAS Y DISTRIBUCION DE COMBUSTIBLES GASEOSOS' },
  { value: 412515, label: 'CAPTACION, DEPURACION Y DISTRIBUCION DE AGUA' },
  { value: 412595, label: 'ACTIVIDADES CONEXAS' },
  { value: 412599, label: 'AJUSTES POR INFLACION' },
  { value: 4130, label: 'CONSTRUCCION' },
  { value: 413005, label: 'PREPARACION DE TERRENOS' },
  { value: 413010, label: 'CONSTRUCCION DE EDIFICIOS Y OBRAS DE INGENIERIA CIVIL' },
  { value: 413015, label: 'ACONDICIONAMIENTO DE EDIFICIOS' },
  { value: 413020, label: 'TERMINACION DE EDIFICACIONES' },
  { value: 413025, label: 'ALQUILER DE EQUIPO CON OPERARIOS' },
  { value: 413095, label: 'ACTIVIDADES CONEXAS' },
  { value: 413099, label: 'AJUSTES POR INFLACION' },
  { value: 4135, label: 'COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: 413502, label: 'VENTA DE VEHICULOS AUTOMOTORES' },
  { value: 413504, label: 'MANTENIMIENTO, REPARACION Y LAVADO DE VEHICULOS AUTOMOTORES' },
  { value: 413506, label: 'VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHICULOS AUTOMOTORES' },
  { value: 413508, label: 'VENTA DE COMBUSTIBLES SOLIDOS, LIQUIDOS, GASEOSOS' },
  { value: 413510, label: 'VENTA DE LUBRICANTES, ADITIVOS, LLANTAS Y LUJOS PARA AUTOMOTORES' },
  { value: 413512, label: 'VENTA A CAMBIO DE RETRIBUCION O POR CONTRATA' },
  { value: 413514, label: 'VENTA DE INSUMOS, MATERIAS PRIMAS AGROPECUARIAS Y FLORES' },
  { value: 413516, label: 'VENTA DE OTROS INSUMOS Y MATERIAS PRIMAS NO AGROPECUARIAS' },
  { value: 413518, label: 'VENTA DE ANIMALES VIVOS Y CUEROS' },
  { value: 413520, label: 'VENTA DE PRODUCTOS EN ALMACENES NO ESPECIALIZADOS' },
  { value: 413522, label: 'VENTA DE PRODUCTOS AGROPECUARIOS' },
  { value: 413524, label: 'VENTA DE PRODUCTOS TEXTILES, DE VESTIR, DE CUERO Y CALZADO' },
  { value: 413526, label: 'VENTA DE PAPEL Y CARTON' },
  { value: 413528, label: 'VENTA DE LIBROS, REVISTAS, ELEMENTOS DE PAPELERIA, UTILES Y TEXTOS ESCOLARES' },
  { value: 413530, label: 'VENTA DE JUEGOS, JUGUETES Y ARTICULOS DEPORTIVOS' },
  { value: 413532, label: 'VENTA DE INSTRUMENTOS QUIRURGICOS Y ORTOPEDICOS' },
  { value: 413534, label: 'VENTA DE ARTICULOS EN RELOJERIAS Y JOYERIAS' },
  { value: 413536, label: 'VENTA DE ELECTRODOMESTICOS Y MUEBLES' },
  { value: 413538, label: 'VENTA DE PRODUCTOS DE ASEO, FARMACEUTICOS, MEDICINALES, Y ARTICULOS DE TOCADOR' },
  { value: 413540, label: 'VENTA DE CUBIERTOS, VAJILLAS, CRISTALERIA, PORCELANAS, CERAMICAS Y OTROS ARTICULOS DE USO DOMESTICO' },
  { value: 413542, label: 'VENTA DE MATERIALES DE CONSTRUCCION, FONTANERIA Y CALEFACCION' },
  { value: 413544, label: 'VENTA DE PINTURAS Y LACAS' },
  { value: 413546, label: 'VENTA DE PRODUCTOS DE VIDRIOS Y MARQUETERIA' },
  { value: 413548, label: 'VENTA DE HERRAMIENTAS Y ARTICULOS DE FERRETERIA' },
  { value: 413550, label: 'VENTA DE QUIMICOS' },
  { value: 413552, label: 'VENTA DE PRODUCTOS INTERMEDIOS, DESPERDICIOS Y DESECHOS' },
  { value: 413554, label: 'VENTA DE MAQUINARIA, EQUIPO DE OFICINA Y PROGRAMAS DE COMPUTADOR' },
  { value: 413556, label: 'VENTA DE ARTICULOS EN CACHARRERIAS Y MISCELANEAS' },
  { value: 413558, label: 'VENTA DE INSTRUMENTOS MUSICALES' },
  { value: 413560, label: 'VENTA DE ARTICULOS EN CASAS DE EMPEÑO Y PRENDERIAS' },
  { value: 413562, label: 'VENTA DE EQUIPO FOTOGRAFICO' },
  { value: 413564, label: 'VENTA DE EQUIPO OPTICO Y DE PRECISION' },
  { value: 413566, label: 'VENTA DE EMPAQUES' },
  { value: 413568, label: 'VENTA DE EQUIPO PROFESIONAL Y CIENTIFICO' },
  //{ value: 413570, label: 'VENTA DE LOTERIAS, RIFAS, CHANCE, APUESTAS Y SIMILARES' },
  { value: 413572, label: 'REPARACION DE EFECTOS PERSONALES Y ELECTRODOMESTICOS' },
  { value: 413595, label: 'VENTA DE OTROS PRODUCTOS' },
  { value: 413599, label: 'AJUSTES POR INFLACION' },
  { value: 4140, label: 'HOTELES Y RESTAURANTES' },
  { value: 414005, label: 'HOTELERIA' },
  { value: 414010, label: 'CAMPAMENTO Y OTROS TIPOS DE HOSPEDAJE' },
  { value: 414015, label: 'RESTAURANTES' },
  { value: 414020, label: 'BARES Y CANTINAS' },
  { value: 414095, label: 'ACTIVIDADES CONEXAS' },
  { value: 414099, label: 'AJUSTES POR INFLACION' },
  { value: 4145, label: 'TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: 414505, label: 'SERVICIO DE TRANSPORTE POR CARRETERA' },
  { value: 414510, label: 'SERVICIO DE TRANSPORTE POR VIA FERREA' },
  { value: 414515, label: 'SERVICIO DE TRANSPORTE POR VIA ACUATICA' },
  { value: 414520, label: 'SERVICIO DE TRANSPORTE POR VIA AEREA' },
  { value: 414525, label: 'SERVICIO DE TRANSPORTE POR TUBERIAS' },
  { value: 414530, label: 'MANIPULACION DE CARGA' },
  { value: 414535, label: 'ALMACENAMIENTO Y DEPOSITO' },
  { value: 414540, label: 'SERVICIOS COMPLEMENTARIOS PARA EL TRANSPORTE' },
  { value: 414545, label: 'AGENCIAS DE VIAJE' },
  { value: 414550, label: 'OTRAS AGENCIAS DE TRANSPORTE' },
  { value: 414555, label: 'SERVICIO POSTAL Y DE CORREO' },
  { value: 414560, label: 'SERVICIO TELEFONICO' },
  { value: 414565, label: 'SERVICIO DE TELEGRAFO' },
  { value: 414570, label: 'SERVICIO DE TRANSMISION DE DATOS' },
  { value: 414575, label: 'SERVICIO DE RADIO Y TELEVISION POR CABLE' },
  { value: 414580, label: 'TRANSMISION DE SONIDO E IMAGENES POR CONTRATO' },
  { value: 414595, label: 'ACTIVIDADES CONEXAS' },
  { value: 414599, label: 'AJUSTES POR INFLACION' },
  { value: 4150, label: 'ACTIVIDAD FINANCIERA' },
  { value: 415005, label: 'VENTA DE INVERSIONES' },
  { value: 415010, label: 'DIVIDENDOS DE SOCIEDADES ANONIMAS Y/O ASIMILADAS' },
  { value: 415015, label: 'PARTICIPACIONES DE SOCIEDADES LIMITADAS Y/O ASIMILADAS' },
  { value: 415020, label: 'INTERESES' },
  { value: 415025, label: 'REAJUSTE MONETARIO - UPAC' },
  { value: 415030, label: 'COMISIONES' },
  { value: 415035, label: 'OPERACIONES DE DESCUENTO' },
  { value: 415040, label: 'CUOTAS DE INSCRIPCION - CONSORCIOS' },
  { value: 415045, label: 'CUOTAS DE ADMINISTRACION - CONSORCIOS' },
  { value: 415050, label: 'REAJUSTE DEL SISTEMA - CONSORCIOS' },
  { value: 415055, label: 'ELIMINACION DE SUSCRIPTORES - CONSORCIOS' },
  { value: 415060, label: 'CUOTAS DE INGRESO O RETIRO - SOCIEDAD ADMINISTRADORA' },
  { value: 415065, label: 'SERVICIOS A COMISIONISTAS' },
  { value: 415070, label: 'INSCRIPCIONES Y CUOTAS' },
  { value: 415075, label: 'RECUPERACION DE GARANTIAS' },
  { value: 415095, label: 'ACTIVIDADES CONEXAS' },
  { value: 415099, label: 'AJUSTES POR INFLACION' },
  { value: 4155, label: 'ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: 415505, label: 'ARRENDAMIENTOS DE BIENES INMUEBLES' },
  { value: 415510, label: 'INMOBILIARIAS POR RETRIBUCION O CONTRATA' },
  { value: 415515, label: 'ALQUILER EQUIPO DE TRANSPORTE' },
  { value: 415520, label: 'ALQUILER MAQUINARIA Y EQUIPO' },
  { value: 415525, label: 'ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMESTICOS' },
  { value: 415530, label: 'CONSULTORIA EN EQUIPO Y PROGRAMAS DE INFORMATICA' },
  { value: 415535, label: 'PROCESAMIENTO DE DATOS' },
  { value: 415540, label: 'MANTENIMIENTO Y REPARACION DE MAQUINARIA DE OFICINA' },
  { value: 415545, label: 'INVESTIGACIONES CIENTIFICAS Y DE DESARROLLO' },
  { value: 415550, label: 'ACTIVIDADES EMPRESARIALES DE CONSULTORIA' },
  { value: 415555, label: 'PUBLICIDAD' },
  { value: 415560, label: 'DOTACION DE PERSONAL' },
  { value: 415565, label: 'INVESTIGACION Y SEGURIDAD' },
  { value: 415570, label: 'LIMPIEZA DE INMUEBLES' },
  { value: 415575, label: 'FOTOGRAFIA' },
  { value: 415580, label: 'ENVASE Y EMPAQUE' },
  { value: 415585, label: 'FOTOCOPIADO' },
  { value: 415590, label: 'MANTENIMIENTO Y REPARACION DE MAQUINARIA Y EQUIPO' },
  { value: 415595, label: 'ACTIVIDADES CONEXAS' },
  { value: 415599, label: 'AJUSTES POR INFLACION' },
  { value: 4160, label: 'ENSEÑANZA' },
  { value: 416005, label: 'ACTIVIDADES RELACIONADAS CON LA EDUCACION' },
  { value: 416095, label: 'ACTIVIDADES CONEXAS' },
  { value: 416099, label: 'AJUSTES POR INFLACION' },
  { value: 4165, label: 'SERVICIOS SOCIALES Y DE SALUD' },
  { value: 416505, label: 'SERVICIO HOSPITALARIO' },
  { value: 416510, label: 'SERVICIO MEDICO' },
  { value: 416515, label: 'SERVICIO ODONTOLOGICO' },
  { value: 416520, label: 'SERVICIO DE LABORATORIO' },
  { value: 416525, label: 'ACTIVIDADES VETERINARIAS' },
  { value: 416530, label: 'ACTIVIDADES DE SERVICIOS SOCIALES' },
  { value: 416595, label: 'ACTIVIDADES CONEXAS' },
  { value: 416599, label: 'AJUSTES POR INFLACION' },
  { value: 4170, label: 'OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: 417005, label: 'ELIMINACION DE DESPERDICIOS Y AGUAS RESIDUALES' },
  { value: 417010, label: 'ACTIVIDADES DE ASOCIACION' },
  { value: 417015, label: 'PRODUCCION Y DISTRIBUCION DE FILMES Y VIDEOCINTAS' },
  { value: 417020, label: 'EXHIBICION DE FILMES Y VIDEOCINTAS' },
  { value: 417025, label: 'ACTIVIDAD DE RADIO Y TELEVISION' },
  { value: 417030, label: 'ACTIVIDAD TEATRAL, MUSICAL Y ARTISTICA' },
  { value: 417035, label: 'GRABACION Y PRODUCCION DE DISCOS' },
  { value: 417040, label: 'ENTRETENIMIENTO Y ESPARCIMIENTO' },
  { value: 417045, label: 'AGENCIAS DE NOTICIAS' },
  { value: 417050, label: 'LAVANDERIAS Y SIMILARES' },
  { value: 417055, label: 'PELUQUERIAS Y SIMILARES' },
  { value: 417060, label: 'SERVICIOS FUNERARIOS' },
  { value: 417065, label: 'ZONAS FRANCAS' },
  { value: 417095, label: 'ACTIVIDADES CONEXAS' },
  { value: 417099, label: 'AJUSTES POR INFLACION' },
  { value: 4175, label: 'DEVOLUCIONES, REBAJAS Y DESCUENTOS EN VENTAS (DB)' },
  { value: 417599, label: 'AJUSTES POR INFLACION' },
  { value: 42, label: 'NO OPERACIONALES' },
  { value: 4205, label: 'OTRAS VENTAS' },
  { value: 420505, label: 'MATERIA PRIMA' },
  { value: 420510, label: 'MATERIAL DE DESECHO' },
  { value: 420515, label: 'MATERIALES VARIOS' },
  { value: 420520, label: 'PRODUCTOS DE DIVERSIFICACION' },
  { value: 420525, label: 'EXCEDENTES DE EXPORTACION' },
  { value: 420530, label: 'ENVASES Y EMPAQUES' },
  { value: 420535, label: 'PRODUCTOS AGRICOLAS' },
  { value: 420540, label: 'DE PROPAGANDA' },
  { value: 420545, label: 'PRODUCTOS EN REMATE' },
  { value: 420550, label: 'COMBUSTIBLES Y LUBRICANTES' },
  { value: 420599, label: 'AJUSTES POR INFLACION' },
  { value: 4210, label: 'FINANCIEROS' },
  { value: 421005, label: 'INTERESES' },
  { value: 421010, label: 'REAJUSTE MONETARIO - UPAC' },
  { value: 421015, label: 'DESCUENTOS AMORTIZADOS' },
  { value: 421020, label: 'DIFERENCIA EN CAMBIO' },
  { value: 421025, label: 'FINANCIACION VEHICULOS' },
  { value: 421030, label: 'FINANCIACION SISTEMAS DE VIAJES' },
  { value: 421035, label: 'ACEPTACIONES BANCARIAS' },
  { value: 421040, label: 'DESCUENTOS COMERCIALES CONDICIONADOS' },
  { value: 421045, label: 'DESCUENTOS BANCARIOS' },
  { value: 421050, label: 'COMISIONES CHEQUES DE OTRAS PLAZAS' },
  { value: 421055, label: 'MULTAS Y RECARGOS' },
  { value: 421060, label: 'SANCIONES CHEQUES DEVUELTOS' },
  { value: 421095, label: 'OTROS' },
  { value: 421099, label: 'AJUSTES POR INFLACION' },
  { value: 4215, label: 'DIVIDENDOS Y PARTICIPACIONES' },
  { value: 421505, label: 'DE SOCIEDADES ANONIMAS Y/O ASIMILADAS' },
  { value: 421510, label: 'DE SOCIEDADES LIMITADAS Y/O ASIMILADAS' },
  { value: 421599, label: 'AJUSTES POR INFLACION' },
  { value: 4220, label: 'ARRENDAMIENTOS' },
  { value: 422005, label: 'TERRENOS' },
  { value: 422010, label: 'CONSTRUCCIONES Y EDIFICIOS' },
  { value: 422015, label: 'MAQUINARIA Y EQUIPO' },
  { value: 422020, label: 'EQUIPO DE OFICINA' },
  { value: 422025, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 422030, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 422035, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 422040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 422045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 422050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 422055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 422060, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 422062, label: 'ENVASES Y EMPAQUES' },
  { value: 422065, label: 'PLANTACIONES AGRICOLAS  Y FORESTALES' },
  { value: 422070, label: 'AERODROMOS' },
  { value: 422075, label: 'SEMOVIENTES' },
  { value: 422099, label: 'AJUSTES POR INFLACION' },
  { value: 4225, label: 'COMISIONES' },
  { value: 422505, label: 'SOBRE INVERSIONES' },
  { value: 422510, label: 'DE CONCESIONARIOS' },
  { value: 422515, label: 'DE ACTIVIDADES FINANCIERAS' },
  { value: 422520, label: 'POR VENTA DE SERVICIOS DE TALLER' },
  { value: 422525, label: 'POR VENTA DE SEGUROS' },
  { value: 422530, label: 'POR INGRESOS PARA TERCEROS' },
  { value: 422535, label: 'POR DISTRIBUCION DE PELICULAS' },
  { value: 422540, label: 'DERECHOS DE AUTOR' },
  { value: 422545, label: 'DERECHOS DE PROGRAMACION' },
  { value: 422599, label: 'AJUSTES POR INFLACION' },
  { value: 4230, label: 'HONORARIOS' },
  { value: 423005, label: 'ASESORIAS' },
  { value: 423010, label: 'ASISTENCIA TECNICA' },
  { value: 423015, label: 'ADMINISTRACION DE VINCULADAS' },
  { value: 423099, label: 'AJUSTES POR INFLACION' },
  { value: 4235, label: 'SERVICIOS' },
  { value: 423505, label: 'DE BASCULA' },
  { value: 423510, label: 'DE TRANSPORTE' },
  { value: 423515, label: 'DE PRENSA' },
  { value: 423520, label: 'ADMINISTRATIVOS' },
  { value: 423525, label: 'TECNICOS' },
  { value: 423530, label: 'DE COMPUTACION' },
  { value: 423535, label: 'DE TELEFAX' },
  { value: 423540, label: 'TALLER DE VEHICULOS' },
  { value: 423545, label: 'DE RECEPCION DE AERONAVES' },
  { value: 423550, label: 'DE TRANSPORTE PROGRAMA GAS NATURAL' },
  { value: 423555, label: 'POR CONTRATOS' },
  { value: 423560, label: 'DE TRILLLA' },
  { value: 423565, label: 'DE MANTENIMIENTO' },
  { value: 423570, label: 'AL PERSONAL' },
  { value: 423575, label: 'DE CASINO' },
  { value: 423580, label: 'FLETES' },
  { value: 423585, label: 'ENTRE COMPAÑIAS' },
  { value: 423595, label: 'OTROS' },
  { value: 423599, label: 'AJUSTES POR INFLACION' },
  { value: 4240, label: 'UTILIDAD EN VENTA DE INVERSIONES' },
  { value: 424005, label: 'ACCIONES' },
  { value: 424010, label: 'CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 424015, label: 'BONOS' },
  { value: 424020, label: 'CEDULAS' },
  { value: 424025, label: 'CERTIFICADOS' },
  { value: 424030, label: 'PAPELES COMERCIALES' },
  { value: 424035, label: 'TITULOS' },
  { value: 424045, label: 'DERECHOS FIDUCIARIOS' },
  { value: 424050, label: 'OBLIGATORIAS' },
  { value: 424095, label: 'OTRAS' },
  { value: 424099, label: 'AJUSTES POR INFLACION' },
  { value: 4245, label: 'UTILIDAD EN VENTA DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 424504, label: 'TERRENOS' },
  { value: 424506, label: 'MATERIALES INDUSTRIA PETROLERA' },
  { value: 424508, label: 'CONSTRUCCIONES EN CURSO' },
  { value: 424512, label: 'MAQUINARIA EN MONTAJE' },
  { value: 424516, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 424520, label: 'MAQUINARIA Y EQUIPO' },
  { value: 424524, label: 'EQUIPO DE OFICINA' },
  { value: 424528, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 424532, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 424536, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 424540, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 424544, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 424548, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 424552, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 424556, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 424560, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 424562, label: 'ENVASES Y EMPAQUES' },
  { value: 424564, label: 'PLANTACIONES AGRICOLAS  Y FORESTALES' },
  { value: 424568, label: 'VIAS DE COMUNICACION' },
  { value: 424572, label: 'MINAS Y CANTERAS' },
  { value: 424580, label: 'POZOS ARTESIANOS' },
  { value: 424584, label: 'YACIMIENTOS' },
  { value: 424588, label: 'SEMOVIENTES' },
  { value: 424599, label: 'AJUSTES POR INFLACION' },
  { value: 4248, label: 'UTILIDAD EN VENTA DE OTROS BIENES' },
  { value: 424805, label: 'INTANGIBLES' },
  { value: 424810, label: 'OTROS ACTIVOS' },
  { value: 424899, label: 'AJUSTES POR INFLACION' },
  { value: 4250, label: 'RECUPERACIONES' },
  { value: 425005, label: 'DEUDAS MALAS' },
  { value: 425010, label: 'SEGUROS' },
  { value: 425015, label: 'RECLAMOS' },
  { value: 425020, label: 'REINTEGRO POR PERSONAL EN COMISION' },
  { value: 425025, label: 'REINTEGRO GARANTIAS' },
  { value: 425030, label: 'DESCUENTOS CONCEDIDOS' },
  { value: 425035, label: 'REINTEGRO PROVISIONES' },
  { value: 425040, label: 'GASTOS BANCARIOS' },
  { value: 425045, label: 'DE DEPRECIACION' },
  { value: 425050, label: 'REINTEGRO DE OTROS COSTOS Y GASTOS' },
  { value: 425099, label: 'AJUSTES POR INFLACION' },
  { value: 4255, label: 'INDEMNIZACIONES' },
  { value: 425505, label: 'POR SINIESTRO' },
  { value: 425510, label: 'POR SUMINISTROS' },
  { value: 425515, label: 'LUCRO CESANTE COMPAÑIAS DE SEGUROS' },
  { value: 425520, label: 'DAÑO EMERGENTE COMPAÑIAS DE SEGUROS' },
  { value: 425525, label: 'POR PERDIDA DE MERCANCIA' },
  { value: 425530, label: 'POR INCUMPLIMIENTO DE CONTRATOS' },
  { value: 425535, label: 'DE TERCEROS' },
  { value: 425540, label: 'POR INCAPACIDADES I.S.S.' },
  { value: 425595, label: 'OTRAS' },
  { value: 425599, label: 'AJUSTES POR INFLACION' },
  { value: 4260, label: 'PARTICIPACIONES EN CONCESIONES' },
  { value: 426099, label: 'AJUSTES POR INFLACION' },
  { value: 4265, label: 'INGRESOS DE EJERCICIOS ANTERIORES' },
  { value: 426599, label: 'AJUSTES POR INFLACION' },
  { value: 4275, label: 'DEVOLUCIONES, REBAJAS Y DESCUENTOS EN OTRAS VENTAS (DB)' },
  { value: 427599, label: 'AJUSTES POR INFLACION' },
  { value: 4295, label: 'DIVERSOS' },
  { value: 429503, label: 'CERT' },
  { value: 429505, label: 'APROVECHAMIENTOS' },
  { value: 429507, label: 'AUXILIOS' },
  { value: 429509, label: 'DONACIONES' },
  { value: 429511, label: 'INGRESOS POR INVESTIGACION Y DESARROLLO' },
  { value: 429513, label: 'POR TRABAJOS EJECUTADOS' },
  { value: 429515, label: 'REGALIAS' },
  { value: 429517, label: 'DERIVADOS DE LAS EXPORTACIONES' },
  { value: 429519, label: 'OTROS INGRESOS DE EXPLOTACION' },
  { value: 429521, label: 'DE LA ACTIVIDAD GANADERA' },
  { value: 429525, label: 'DERECHOS Y LICITACIONES' },
  { value: 429530, label: 'INGRESOS POR ELEMENTOS PERDIDOS' },
  { value: 429533, label: 'MULTAS Y RECARGOS' },
  { value: 429535, label: 'PREAVISOS DESCONTADOS' },
  { value: 429537, label: 'RECLAMOS' },
  { value: 429540, label: 'RECOBRO DE DAÑOS' },
  { value: 429543, label: 'PREMIOS' },
  { value: 429545, label: 'BONIFICACIONES' },
  { value: 429547, label: 'PRODUCTOS DESCONTADOS' },
  { value: 429549, label: 'RECONOCIMIENTOS I.S.S.' },
  { value: 429551, label: 'EXCEDENTES' },
  { value: 429553, label: 'SOBRANTES DE CAJA MENOR' },
  { value: 429555, label: 'SOBRANTES EN LIQUIDACION FLETES' },
  { value: 429557, label: 'SUBSIDIOS ESTATALES' },
  { value: 429559, label: 'CAPACITACION DISTRIBUIDORES' },
  { value: 429561, label: 'DE ESCRITURACION' },
  { value: 429563, label: 'REGISTRO PROMESAS DE VENTA' },
  { value: 429567, label: 'UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: 429571, label: 'RESULTADOS MATRICULAS Y TRASPASOS' },
  { value: 429573, label: 'DECORACIONES' },
  { value: 429575, label: 'MANEJO DE CARGA' },
  { value: 429579, label: 'HISTORIA CLINICA' },
  { value: 429581, label: 'AJUSTE AL PESO' },
  { value: 429583, label: 'LLAMADAS TELEFONICAS' },
  { value: 429599, label: 'AJUSTES POR INFLACION' },
  { value: 47, label: 'AJUSTES POR INFLACION' },
  { value: 4705, label: 'CORRECCION MONETARIA' },
  { value: 470505, label: 'INVERSIONES (CR)' },
  { value: 470510, label: 'INVENTARIOS (CR)' },
  { value: 470515, label: 'PROPIEDADES, PLANTA Y EQUIPO (CR)' },
  { value: 470520, label: 'INTANGIBLES (CR)' },
  { value: 470525, label: 'ACTIVOS DIFERIDOS' },
  { value: 470530, label: 'OTROS ACTIVOS (CR)' },
  { value: 470535, label: 'PASIVOS SUJETOS DE AJUSTE' },
  { value: 470540, label: 'PATRIMONIO' },
  { value: 470545, label: 'DEPRECIACION ACUMULADA (DB)' },
  { value: 470550, label: 'DEPRECIACION DIFERIDA (CR)' },
  { value: 470555, label: 'AGOTAMIENTO ACUMULADO (DB)' },
  { value: 470560, label: 'AMORTIZACION ACUMULADA (DB)' },
  { value: 470565, label: 'INGRESOS OPERACIONALES (DB)' },
  { value: 470570, label: 'INGRESOS NO OPERACIONALES (DB)' },
  { value: 470575, label: 'GASTOS OPERACIONALES DE ADMINISTRACION (CR)' },
  { value: 470580, label: 'GASTOS OPERACIONALES DE VENTAS (CR)' },
  { value: 470585, label: 'GASTOS NO OPERACIONALES (CR)' },
  { value: 470590, label: 'COMPRAS (CR)' },
  { value: 470592, label: 'COSTO DE VENTAS (CR)' },
  { value: 470594, label: 'COSTOS DE PRODUCCION O DE OPERACION (DB)' },
  { value: 5, label: 'GASTOS' },
  { value: 51, label: 'OPERACIONALES DE ADMINISTRACION' },
  { value: 5105, label: 'GASTOS DE PERSONAL' },
  { value: 510503, label: 'SALARIO INTEGRAL' },
  { value: 510506, label: 'SUELDOS' },
  { value: 510512, label: 'JORNALES' },
  { value: 510515, label: 'HORAS EXTRAS Y RECARGOS' },
  { value: 510518, label: 'COMISIONES' },
  { value: 510521, label: 'VIATICOS' },
  { value: 510524, label: 'INCAPACIDADES' },
  { value: 510527, label: 'AUXILIO DE TRANSPORTE' },
  { value: 510530, label: 'CESANTIAS' },
  { value: 510533, label: 'INTERESES SOBRE CESANTIAS' },
  { value: 510536, label: 'PRIMA DE SERVICIOS' },
  { value: 510539, label: 'VACACIONES' },
  { value: 510542, label: 'PRIMAS EXTRALEGALES' },
  { value: 510545, label: 'AUXILIOS' },
  { value: 510548, label: 'BONIFICACIONES' },
  { value: 510551, label: 'DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: 510554, label: 'SEGUROS' },
  { value: 510557, label: 'CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: 510558, label: 'AMORTIZACION CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: 510559, label: 'PENSIONES DE JUBILACION' },
  { value: 510560, label: 'INDEMNIZACIONES LABORALES' },
  { value: 510563, label: 'CAPACITACION AL PERSONAL' },
  { value: 510566, label: 'GASTOS DEPORTIVOS Y DE RECREACION' },
  { value: 510569, label: 'APORTES AL I.S.S' },
  { value: 510572, label: 'APORTES CAJAS DE COMPENSACION FAMILIAR' },
  { value: 510575, label: 'APORTES I.C.B.F.' },
  { value: 510578, label: 'SENA' },
  { value: 510581, label: 'APORTES SINDICALES' },
  { value: 510584, label: 'GASTOS MEDICOS Y DROGAS' },
  { value: 510595, label: 'OTROS' },
  { value: 510599, label: 'AJUSTES POR INFLACION' },
  { value: 5110, label: 'HONORARIOS' },
  { value: 511005, label: 'JUNTA DIRECTIVA' },
  { value: 511010, label: 'REVISORIA FISCAL' },
  { value: 511015, label: 'AUDITORIA EXTERNA' },
  { value: 511020, label: 'AVALUOS' },
  { value: 511025, label: 'ASESORIA JURIDICA' },
  { value: 511030, label: 'ASESORIA FINANCIERA' },
  { value: 511035, label: 'ASESORIA TECNICA' },
  { value: 511095, label: 'OTROS' },
  { value: 511099, label: 'AJUSTES POR INFLACION' },
  { value: 5115, label: 'IMPUESTOS' },
  { value: 511505, label: 'INDUSTRIA Y COMERCIO' },
  { value: 511510, label: 'DE TIMBRES' },
  { value: 511515, label: 'A LA PROPIEDAD RAIZ' },
  { value: 511520, label: 'DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: 511525, label: 'DE VALORIZACION' },
  { value: 511530, label: 'DE TURISMO' },
  { value: 511535, label: 'TASA POR UTILIZACION DE PUERTOS' },
  { value: 511540, label: 'DE VEHICULOS' },
  { value: 511545, label: 'DE ESPECTACULOS PUBLICOS' },
  { value: 511550, label: 'CUOTAS DE FOMENTO' },
  { value: 511570, label: 'IVA DESCONTABLE' },
  { value: 511595, label: 'OTROS' },
  { value: 511599, label: 'AJUSTES POR INFLACION' },
  { value: 5120, label: 'ARRENDAMIENTOS' },
  { value: 512005, label: 'TERRENOS' },
  { value: 512010, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 512015, label: 'MAQUINARIA Y EQUIPO' },
  { value: 512020, label: 'EQUIPO DE OFICINA' },
  { value: 512025, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 512030, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 512035, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 512040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 512045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 512050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 512055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 512060, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 512065, label: 'AERODROMOS' },
  { value: 512070, label: 'SEMOVIENTES' },
  { value: 512095, label: 'OTROS' },
  { value: 512099, label: 'AJUSTES POR INFLACION' },
  { value: 5125, label: 'CONTRIBUCIONES Y AFILIACIONES' },
  { value: 512505, label: 'CONTRIBUCIONES' },
  { value: 512510, label: 'AFILIACIONES Y SOSTENIMIENTO' },
  { value: 512599, label: 'AJUSTES POR INFLACION' },
  { value: 5130, label: 'SEGUROS' },
  { value: 513005, label: 'MANEJO' },
  { value: 513010, label: 'CUMPLIMIENTO' },
  { value: 513015, label: 'CORRIENTE DEBIL' },
  { value: 513020, label: 'VIDA COLECTIVA' },
  { value: 513025, label: 'INCENDIO' },
  { value: 513030, label: 'TERREMOTO' },
  { value: 513035, label: 'SUSTRACCION Y HURTO' },
  { value: 513040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 513045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 513050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 513055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 513060, label: 'RESPONSABILIDAD CIVIL Y EXTRACONTRACTUAL' },
  { value: 513065, label: 'VUELO' },
  { value: 513070, label: 'ROTURA DE MAQUINARIA' },
  { value: 513075, label: 'OBLIGATORIO ACCIDENTE DE TRANSITO' },
  { value: 513080, label: 'LUCRO CESANTE' },
  { value: 513095, label: 'OTROS' },
  { value: 513099, label: 'AJUSTES POR INFLACION' },
  { value: 5135, label: 'SERVICIOS' },
  { value: 513505, label: 'ASEO Y VIGILANCIA' },
  { value: 513510, label: 'TEMPORALES' },
  { value: 513515, label: 'ASISTENCIA TECNICA' },
  { value: 513520, label: 'PROCESAMIENTO ELECTRONICO DE DATOS' },
  { value: 513525, label: 'ACUEDUCTO Y ALCANTARILLADO' },
  { value: 513530, label: 'ENERGIA ELECTRICA' },
  { value: 513535, label: 'TELEFONO' },
  { value: 513540, label: 'CORREO, PORTES Y TELEGRAMAS' },
  { value: 513545, label: 'FAX Y TELEX' },
  { value: 513550, label: 'TRANSPORTE, FLETES Y ACARREOS' },
  { value: 513555, label: 'GAS' },
  { value: 513595, label: 'OTROS' },
  { value: 513599, label: 'AJUSTES POR INFLACION' },
  { value: 5140, label: 'GASTOS LEGALES' },
  { value: 514005, label: 'NOTARIALES' },
  { value: 514010, label: 'REGISTRO MERCANTIL' },
  { value: 514015, label: 'TRAMITES Y LICENCIAS' },
  { value: 514020, label: 'ADUANEROS' },
  { value: 514025, label: 'CONSULARES' },
  { value: 514095, label: 'OTROS' },
  { value: 514099, label: 'AJUSTES POR INFLACION' },
  { value: 5145, label: 'MANTENIMIENTO Y REPARACIONES' },
  { value: 514505, label: 'TERRENOS' },
  { value: 514510, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 514515, label: 'MAQUINARIA Y EQUIPO' },
  { value: 514520, label: 'EQUIPO DE OFICINA' },
  { value: 514525, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 514530, label: 'EQUIPO MEDICO-CIENTIFICO' },
  { value: 514535, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 514540, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 514545, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 514550, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 514555, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 514560, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 514565, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 514570, label: 'VIAS DE COMUNICACION' },
  { value: 514599, label: 'AJUSTES POR INFLACION' },
  { value: 5150, label: 'ADECUACION E INSTALACION' },
  { value: 515005, label: 'INSTALACIONES ELECTRICAS' },
  { value: 515010, label: 'ARREGLOS ORNAMENTALES' },
  { value: 515015, label: 'REPARACIONES LOCATIVAS' },
  { value: 515095, label: 'OTROS' },
  { value: 515099, label: 'AJUSTES POR INFLACION' },
  { value: 5155, label: 'GASTOS DE VIAJE' },
  { value: 515505, label: 'ALOJAMIENTO Y MANUTENCION' },
  { value: 515510, label: 'PASAJES FLUVIALES Y/O MARITIMOS' },
  { value: 515515, label: 'PASAJES AEREOS' },
  { value: 515520, label: 'PASAJES TERRESTRES' },
  { value: 515525, label: 'PASAJES FERREOS' },
  { value: 515595, label: 'OTROS' },
  { value: 515599, label: 'AJUSTES POR INFLACION' },
  { value: 5160, label: 'DEPRECIACIONES' },
  { value: 516005, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 516010, label: 'MAQUINARIA Y EQUIPO' },
  { value: 516015, label: 'EQUIPO DE OFICINA' },
  { value: 516020, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 516025, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 516030, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 516035, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 516040, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 516045, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 516050, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 516055, label: 'ACUEDUCTOS, PLANTAS Y REDES' },
  { value: 516060, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 516099, label: 'AJUSTES POR INFLACION' },
  { value: 5165, label: 'AMORTIZACIONES' },
  { value: 516505, label: 'VIAS DE COMUNICACION' },
  { value: 516510, label: 'INTANGIBLES' },
  { value: 516515, label: 'CARGOS DIFERIDOS' },
  { value: 516595, label: 'OTRAS' },
  { value: 516599, label: 'AJUSTES POR INFLACION' },
  { value: 5195, label: 'DIVERSOS' },
  { value: 519505, label: 'COMISIONES' },
  { value: 519510, label: 'LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: 519515, label: 'MUSICA AMBIENTAL' },
  { value: 519520, label: 'GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: 519525, label: 'ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: 519530, label: 'UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: 519535, label: 'COMBUSTIBLES Y LUBRICANTES' },
  { value: 519540, label: 'ENVASES Y EMPAQUES' },
  { value: 519545, label: 'TAXIS Y BUSES' },
  { value: 519550, label: 'ESTAMPILLAS' },
  { value: 519555, label: 'MICROFILMACION' },
  { value: 519560, label: 'CASINO Y RESTAURANTE' },
  { value: 519565, label: 'PARQUEADEROS' },
  { value: 519570, label: 'INDEMNIZACION POR DAÑOS A TERCEROS' },
  { value: 519575, label: 'POLVORA Y SIMILARES' },
  { value: 519595, label: 'OTROS' },
  { value: 519599, label: 'AJUSTES POR INFLACION' },
  { value: 5199, label: 'PROVISIONES' },
  { value: 519905, label: 'INVERSIONES' },
  { value: 519910, label: 'DEUDORES' },
  { value: 519915, label: 'PROPIEDADES, PLANTA Y EQUIPO' },
  { value: 519995, label: 'OTROS ACTIVOS' },
  { value: 519999, label: 'AJUSTES POR INFLACION' },
  { value: 52, label: 'OPERACIONALES DE VENTAS' },
  { value: 5205, label: 'GASTOS DE PERSONAL' },
  { value: 520503, label: 'SALARIO INTEGRAL' },
  { value: 520506, label: 'SUELDOS' },
  { value: 520512, label: 'JORNALES' },
  { value: 520515, label: 'HORAS EXTRAS Y RECARGOS' },
  { value: 520518, label: 'COMISIONES' },
  { value: 520521, label: 'VIATICOS' },
  { value: 520524, label: 'INCAPACIDADES' },
  { value: 520527, label: 'AUXILIO DE TRANSPORTE' },
  { value: 520530, label: 'CESANTIAS' },
  { value: 520533, label: 'INTERESES SOBRE CESANTIAS' },
  { value: 520536, label: 'PRIMA DE SERVICIOS' },
  { value: 520539, label: 'VACACIONES' },
  { value: 520542, label: 'PRIMAS EXTRALEGALES' },
  { value: 520545, label: 'AUXILIOS' },
  { value: 520548, label: 'BONIFICACIONES' },
  { value: 520551, label: 'DOTACION Y SUMINISTRO A TRABAJADORES' },
  { value: 520554, label: 'SEGUROS' },
  { value: 520557, label: 'CUOTAS PARTES PENSIONES DE JUBILACION' },
  { value: 520558, label: 'AMORTIZACION CALCULO ACTUARIAL PENSIONES DE JUBILACION' },
  { value: 520559, label: 'PENSIONES DE JUBILACION' },
  { value: 520560, label: 'INDEMNIZACIONES LABORALES' },
  { value: 520563, label: 'CAPACITACION AL PERSONAL' },
  { value: 520566, label: 'GASTOS DEPORTIVOS Y DE RECREACION' },
  { value: 520569, label: 'APORTES AL I.S.S' },
  { value: 520572, label: 'APORTES CAJAS DE COMPENSACION FAMILIAR' },
  { value: 520575, label: 'APORTES I.C.B.F.' },
  { value: 520578, label: 'SENA' },
  { value: 520581, label: 'APORTES SINDICALES' },
  { value: 520584, label: 'GASTOS MEDICOS Y DROGAS' },
  { value: 520595, label: 'OTROS' },
  { value: 520599, label: 'AJUSTES POR INFLACION' },
  { value: 5210, label: 'HONORARIOS' },
  { value: 521005, label: 'JUNTA DIRECTIVA' },
  { value: 521010, label: 'REVISORIA FISCAL' },
  { value: 521015, label: 'AUDITORIA EXTERNA' },
  { value: 521020, label: 'AVALUOS' },
  { value: 521025, label: 'ASESORIA JURIDICA' },
  { value: 521030, label: 'ASESORIA FINANCIERA' },
  { value: 521035, label: 'ASESORIA TECNICA' },
  { value: 521095, label: 'OTROS' },
  { value: 521099, label: 'AJUSTES POR INFLACION' },
  { value: 5215, label: 'IMPUESTOS' },
  { value: 521505, label: 'INDUSTRIA Y COMERCIO' },
  { value: 521510, label: 'DE TIMBRES' },
  { value: 521515, label: 'A LA PROPIEDAD RAIZ' },
  { value: 521520, label: 'DERECHOS SOBRE INSTRUMENTOS PUBLICOS' },
  { value: 521525, label: 'DE VALORIZACION' },
  { value: 521530, label: 'DE TURISMO' },
  { value: 521535, label: 'TASA POR UTILIZACION DE PUERTOS' },
  { value: 521540, label: 'DE VEHICULOS' },
  { value: 521545, label: 'DE ESPECTACULOS PUBLICOS' },
  { value: 521550, label: 'CUOTAS DE FOMENTO' },
  { value: 521555, label: 'LICORES' },
  { value: 521560, label: 'CERVEZAS' },
  { value: 521565, label: 'CIGARRILLOS' },
  { value: 521570, label: 'IVA DESCONTABLE' },
  { value: 521595, label: 'OTROS' },
  { value: 521599, label: 'AJUSTES POR INFLACION' },
  { value: 5220, label: 'ARRENDAMIENTOS' },
  { value: 522005, label: 'TERRENOS' },
  { value: 522010, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 522015, label: 'MAQUINARIA Y EQUIPO' },
  { value: 522020, label: 'EQUIPO DE OFICINA' },
  { value: 522025, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 522030, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 522035, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 522040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 522045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 522050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 522055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 522060, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 522065, label: 'AERODROMOS' },
  { value: 522070, label: 'SEMOVIENTES' },
  { value: 522095, label: 'OTROS' },
  { value: 522099, label: 'AJUSTES POR INFLACION' },
  { value: 5225, label: 'CONTRIBUCIONES Y AFILIACIONES' },
  { value: 522505, label: 'CONTRIBUCIONES' },
  { value: 522510, label: 'AFILIACIONES Y SOSTENIMIENTO' },
  { value: 522599, label: 'AJUSTES POR INFLACION' },
  { value: 5230, label: 'SEGUROS' },
  { value: 523005, label: 'MANEJO' },
  { value: 523010, label: 'CUMPLIMIENTO' },
  { value: 523015, label: 'CORRIENTE DEBIL' },
  { value: 523020, label: 'VIDA COLECTIVA' },
  { value: 523025, label: 'INCENDIO' },
  { value: 523030, label: 'TERREMOTO' },
  { value: 523035, label: 'SUSTRACCION Y HURTO' },
  { value: 523040, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 523045, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 523050, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 523055, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 523060, label: 'RESPONSABILIDAD CIVIL Y EXTRACONTRACTUAL' },
  { value: 523065, label: 'VUELO' },
  { value: 523070, label: 'ROTURA DE MAQUINARIA' },
  { value: 523075, label: 'OBLIGATORIO ACCIDENTE DE TRANSITO' },
  { value: 523080, label: 'LUCRO CESANTE' },
  { value: 523095, label: 'OTROS' },
  { value: 523099, label: 'AJUSTES POR INFLACION' },
  { value: 5235, label: 'SERVICIOS' },
  { value: 523505, label: 'ASEO Y VIGILANCIA' },
  { value: 523510, label: 'TEMPORALES' },
  { value: 523515, label: 'ASISTENCIA TECNICA' },
  { value: 523520, label: 'PROCESAMIENTO ELECTRONICO DE DATOS' },
  { value: 523525, label: 'ACUEDUCTO Y ALCANTARILLADO' },
  { value: 523530, label: 'ENERGIA ELECTRICA' },
  { value: 523535, label: 'TELEFONO' },
  { value: 523540, label: 'CORREO, PORTES Y TELEGRAMAS' },
  { value: 523545, label: 'FAX Y TELEX' },
  { value: 523550, label: 'TRANSPORTE, FLETES Y ACARREOS' },
  { value: 523555, label: 'GAS' },
  { value: 523560, label: 'PROPAGANDA Y PUBLICIDAD' },
  { value: 523595, label: 'OTROS' },
  { value: 523599, label: 'AJUSTES POR INFLACION' },
  { value: 5240, label: 'GASTOS LEGALES' },
  { value: 524005, label: 'NOTARIALES' },
  { value: 524010, label: 'REGISTRO MERCANTIL' },
  { value: 524015, label: 'TRAMITES Y LICENCIAS' },
  { value: 524020, label: 'ADUANEROS' },
  { value: 524025, label: 'CONSULARES' },
  { value: 524095, label: 'OTROS' },
  { value: 524099, label: 'AJUSTES POR INFLACION' },
  { value: 5245, label: 'MANTENIMIENTO Y REPARACIONES' },
  { value: 524505, label: 'TERRENOS' },
  { value: 524510, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 524515, label: 'MAQUINARIA Y EQUIPO' },
  { value: 524520, label: 'EQUIPO DE OFICINA' },
  { value: 524525, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 524530, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 524535, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 524540, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 524545, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 524550, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 524555, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 524560, label: 'ACUEDUCTOS PLANTAS Y REDES' },
  { value: 524565, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 524570, label: 'VIAS DE COMUNICACION' },
  { value: 524599, label: 'AJUSTES POR INFLACION' },
  { value: 5250, label: 'ADECUACION E INSTALACION' },
  { value: 525005, label: 'INSTALACIONES ELECTRICAS' },
  { value: 525010, label: 'ARREGLOS ORNAMENTALES' },
  { value: 525015, label: 'REPARACIONES LOCATIVAS' },
  { value: 525095, label: 'OTROS' },
  { value: 525099, label: 'AJUSTES POR INFLACION' },
  { value: 5255, label: 'GASTOS DE VIAJE' },
  { value: 525505, label: 'ALOJAMIENTO Y MANUTENCION' },
  { value: 525510, label: 'PASAJES FLUVIALES Y/O MARITIMOS' },
  { value: 525515, label: 'PASAJES AEREOS' },
  { value: 525520, label: 'PASAJES TERRESTRES' },
  { value: 525525, label: 'PASAJES FERREOS' },
  { value: 525595, label: 'OTROS' },
  { value: 525599, label: 'AJUSTES POR INFLACION' },
  { value: 5260, label: 'DEPRECIACIONES' },
  { value: 526005, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 526010, label: 'MAQUINARIA Y EQUIPO' },
  { value: 526015, label: 'EQUIPO DE OFICINA' },
  { value: 526020, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 526025, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 526030, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 526035, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 526040, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 526045, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 526050, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 526055, label: 'ACUEDUCTOS, PLANTAS Y REDES' },
  { value: 526060, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 526065, label: 'ENVASES Y EMPAQUES' },
  { value: 526099, label: 'AJUSTES POR INFLACION' },
  { value: 5265, label: 'AMORTIZACIONES' },
  { value: 526505, label: 'VIAS DE COMUNICACION' },
  { value: 526510, label: 'INTANGIBLES' },
  { value: 526515, label: 'CARGOS DIFERIDOS' },
  { value: 526595, label: 'OTRAS' },
  { value: 526599, label: 'AJUSTES POR INFLACION' },
  { value: 5270, label: 'FINANCIEROS - REAJUSTE DEL SISTEMA' },
  { value: 527001, label: 'a 527098' },
  { value: 527099, label: 'AJUSTES POR INFLACION' },
  { value: 5295, label: 'DIVERSOS' },
  { value: 529505, label: 'COMISIONES' },
  { value: 529510, label: 'LIBROS, SUSCRIPCIONES, PERIODICOS Y REVISTAS' },
  { value: 529515, label: 'MUSICA AMBIENTAL' },
  { value: 529520, label: 'GASTOS DE REPRESENTACION Y RELACIONES PUBLICAS' },
  { value: 529525, label: 'ELEMENTOS DE ASEO Y CAFETERIA' },
  { value: 529530, label: 'UTILES, PAPELERIA Y FOTOCOPIAS' },
  { value: 529535, label: 'COMBUSTIBLES Y LUBRICANTES' },
  { value: 529540, label: 'ENVASES Y EMPAQUES' },
  { value: 529545, label: 'TAXIS Y BUSES' },
  { value: 529550, label: 'ESTAMPILLAS' },
  { value: 529555, label: 'MICROFILMACION' },
  { value: 529560, label: 'CASINO Y RESTAURANTE' },
  { value: 529565, label: 'PARQUEADEROS' },
  { value: 529570, label: 'INDEMNIZACION POR DAÑOS A TERCEROS' },
  { value: 529575, label: 'POLVORA Y SIMILARES' },
  { value: 529595, label: 'OTROS' },
  { value: 529599, label: 'AJUSTES POR INFLACION' },
  { value: 5299, label: 'PROVISIONES' },
  { value: 529905, label: 'INVERSIONES' },
  { value: 529910, label: 'DEUDORES' },
  { value: 529915, label: 'INVENTARIOS' },
  { value: 529920, label: 'PROPIEDADES, PLANTA Y EQUIPO' },
  { value: 529995, label: 'OTROS ACTIVOS' },
  { value: 529999, label: 'AJUSTES POR INFLACION' },
  { value: 53, label: 'NO OPERACIONALES' },
  { value: 5305, label: 'FINANCIEROS' },
  { value: 530505, label: 'GASTOS BANCARIOS' },
  { value: 530510, label: 'REAJUSTE MONETARIO - UPAC' },
  { value: 530515, label: 'COMISIONES' },
  { value: 530520, label: 'INTERESES' },
  { value: 530525, label: 'DIFERENCIA EN CAMBIO' },
  { value: 530530, label: 'GASTOS EN NEGOCIACION CERTIFICADOS DE CAMBIO' },
  { value: 530535, label: 'DESCUENTOS COMERCIALES CONDICIONADOS' },
  { value: 530540, label: 'GASTOS MANEJO Y EMISION DE BONOS' },
  { value: 530545, label: 'PRIMA AMORTIZADA' },
  { value: 530595, label: 'OTROS' },
  { value: 530599, label: 'AJUSTES POR INFLACION' },
  { value: 5310, label: 'PERDIDA EN VENTA Y RETIRO DE BIENES' },
  { value: 531005, label: 'VENTA DE INVERSIONES' },
  { value: 531010, label: 'VENTA DE CARTERA' },
  { value: 531015, label: 'VENTA DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 531020, label: 'VENTA DE INTANGIBLES' },
  { value: 531025, label: 'VENTA DE OTROS ACTIVOS' },
  { value: 531030, label: 'RETIRO DE PROPIEDADES PLANTA Y EQUIPO' },
  { value: 531035, label: 'RETIRO DE OTROS ACTIVOS' },
  { value: 531040, label: 'PERDIDAS POR SINIESTROS' },
  { value: 531095, label: 'OTROS' },
  { value: 531099, label: 'AJUSTES POR INFLACION' },
  { value: 5315, label: 'GASTOS EXTRAORDINARIOS' },
  { value: 531505, label: 'COSTAS Y PROCESOS JUDICIALES' },
  { value: 531510, label: 'ACTIVIDADES CULTURALES Y CIVICAS' },
  { value: 531515, label: 'COSTOS Y GASTOS DE EJERCICIOS ANTERIORES' },
  { value: 531520, label: 'IMPUESTOS ASUMIDOS' },
  { value: 531595, label: 'OTROS' },
  { value: 531599, label: 'AJUSTES POR INFLACION' },
  { value: 5395, label: 'GASTOS DIVERSOS' },
  { value: 539505, label: 'DEMANDAS LABORALES' },
  { value: 539510, label: 'DEMANDAS POR INCUMPLIMIENTO DE CONTRATOS' },
  { value: 539515, label: 'INDEMNIZACIONES' },
  { value: 539520, label: 'MULTAS, SANCIONES Y LITIGIOS' },
  { value: 539525, label: 'DONACIONES' },
  { value: 539530, label: 'CONSTITUCION DE GARANTIAS' },
  { value: 539535, label: 'AMORTIZACION DE BIENES ENTREGADOS EN COMODATO' },
  { value: 539595, label: 'OTROS' },
  { value: 539599, label: 'AJUSTES POR INFLACION' },
  { value: 54, label: 'IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: 5405, label: 'IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: 540505, label: 'IMPUESTO DE RENTA Y COMPLEMENTARIOS' },
  { value: 59, label: 'GANANCIAS Y PERDIDAS' },
  { value: 5905, label: 'GANANCIAS Y PERDIDAS' },
  { value: 590505, label: 'GANANCIAS Y PERDIDAS' },
  { value: 6, label: 'COSTOS DE VENTAS' },
  { value: 61, label: 'COSTO DE VENTAS Y DE PRESTACION DE SERVICIOS' },
  { value: 6105, label: 'AGRICULTURA, GANADERIA, CAZA Y SILVICULTURA' },
  { value: 610505, label: 'CULTIVO DE CEREALES' },
  { value: 610510, label: 'CULTIVOS DE HORTALIZAS, LEGUMBRES Y PLANTAS ORNAMENTALES' },
  { value: 610515, label: 'CULTIVOS DE FRUTAS, NUECES Y PLANTAS AROMATICAS' },
  { value: 610520, label: 'CULTIVO DE CAFE' },
  { value: 610525, label: 'CULTIVO DE FLORES' },
  { value: 610530, label: 'CULTIVO DE CAÑA DE AZUCAR' },
  { value: 610535, label: 'CULTIVO DE ALGODON Y PLANTAS PARA MATERIAL TEXTIL' },
  { value: 610540, label: 'CULTIVO DE BANANO' },
  { value: 610545, label: 'OTROS CULTIVOS AGRICOLAS' },
  { value: 610550, label: 'CRIA DE OVEJAS, CABRAS, ASNOS, MULAS Y BURDEGANOS' },
  { value: 610555, label: 'CRIA DE GANADO CABALLAR Y VACUNO.' },
  { value: 610560, label: 'PRODUCCION AVICOLA' },
  { value: 610565, label: 'CRIA DE OTROS ANIMALES' },
  { value: 610570, label: 'SERVICIOS AGRICOLAS Y GANADEROS' },
  { value: 610575, label: 'ACTIVIDAD DE CAZA' },
  { value: 610580, label: 'ACTIVIDAD DE SILVICULTURA' },
  { value: 610595, label: 'ACTIVIDADES CONEXAS' },
  { value: 610599, label: 'AJUSTES POR INFLACION' },
  { value: 6110, label: 'PESCA' },
  { value: 611005, label: 'ACTIVIDAD DE PESCA' },
  { value: 611010, label: 'EXPLOTACION DE CRIADEROS DE PECES' },
  { value: 611095, label: 'ACTIVIDADES CONEXAS' },
  { value: 611099, label: 'AJUSTES POR INFLACION' },
  { value: 6115, label: 'EXPLOTACION DE MINAS Y CANTERAS' },
  { value: 611505, label: 'CARBON' },
  { value: 611510, label: 'PETROLEO CRUDO' },
  { value: 611512, label: 'GAS NATURAL' },
  { value: 611514, label: 'SERVICIOS RELACIONADOS CON EXTRACCION DE PETROLEO Y GAS' },
  { value: 611515, label: 'MINERALES DE HIERRO' },
  { value: 611520, label: 'MINERALES METALIFEROS NO FERROSOS' },
  { value: 611525, label: 'PIEDRA, ARENA Y ARCILLA' },
  { value: 611527, label: 'PIEDRAS PRECIOSAS' },
  { value: 611528, label: 'ORO' },
  { value: 611530, label: 'OTRAS MINAS Y CANTERAS' },
  { value: 611532, label: 'PRESTACION DE SERVICIOS SECTOR MINERO' },
  { value: 611595, label: 'ACTIVIDADES CONEXAS' },
  { value: 611599, label: 'AJUSTES POR INFLACION' },
  { value: 6120, label: 'INDUSTRIAS MANUFACTURERAS' },
  { value: 612001, label: 'PRODUCCION Y PROCESAMIENTO DE CARNES Y PRODUCTOS CARNICOS' },
  { value: 612002, label: 'PRODUCTOS DE PESCADO' },
  { value: 612003, label: 'PRODUCTOS DE FRUTAS, LEGUMBRES Y HORTALIZAS' },
  { value: 612004, label: 'ELABORACION DE ACEITES Y GRASAS' },
  { value: 612005, label: 'ELABORACION DE PRODUCTOS LACTEOS' },
  { value: 612006, label: 'ELABORACION DE PRODUCTOS DE MOLINERIA' },
  { value: 612007, label: 'ELABORACION DE ALMIDONES Y DERIVADOS' },
  { value: 612008, label: 'ELABORACION DE ALIMENTOS PARA ANIMALES' },
  { value: 612009, label: 'ELABORACION DE PRODUCTOS PARA PANADERIA' },
  { value: 612010, label: 'ELABORACION DE AZUCAR Y MELAZAS' },
  { value: 612011, label: 'ELABORACION DE CACAO, CHOCOLATE Y CONFITERIA' },
  { value: 612012, label: 'ELABORACION DE PASTAS  Y PRODUCTOS FARINACEOS' },
  { value: 612013, label: 'ELABORACION DE PRODUCTOS DE CAFE' },
  { value: 612014, label: 'ELABORACION DE OTROS PRODUCTOS ALIMENTICIOS' },
  { value: 612015, label: 'ELABORACION DE BEBIDAS ALCOHOLICAS Y ALCOHOL ETILICO' },
  { value: 612016, label: 'ELABORACION DE VINOS' },
  { value: 612017, label: 'ELABORACION DE BEBIDAS MALTEADAS Y DE MALTA' },
  { value: 612018, label: 'ELABORACION DE BEBIDAS NO ALCOHOLICAS' },
  { value: 612019, label: 'ELABORACION DE PRODUCTOS DE TABACO' },
  { value: 612020, label: 'PREPARACION E HILATURA DE FIBRAS TEXTILES Y TEJEDURIA' },
  { value: 612021, label: 'ACABADO DE PRODUCTOS TEXTILES' },
  { value: 612022, label: 'ELABORACION DE ARTICULOS DE MATERIALES TEXTILES' },
  { value: 612023, label: 'ELABORACION DE TAPICES Y ALFOMBRAS' },
  { value: 612024, label: 'ELABORACION DE CUERDAS, CORDELES, BRAMANTES Y REDES' },
  { value: 612025, label: 'ELABORACION DE OTROS PRODUCTOS TEXTILES' },
  { value: 612026, label: 'ELABORACION DE TEJIDOS' },
  { value: 612027, label: 'ELABORACION DE PRENDAS DE VESTIR' },
  { value: 612028, label: 'PREPARACION, ADOBO Y TEÑIDO DE PIELES' },
  { value: 612029, label: 'CURTIDO, ADOBO O PREPARACION DE CUERO' },
  { value: 612030, label: 'ELABORACION DE MALETAS, BOLSOS Y SIMILARES' },
  { value: 612031, label: 'ELABORACION DE CALZADO' },
  { value: 612032, label: 'PRODUCCION DE MADERA, ARTICULOS DE MADERA Y CORCHO' },
  { value: 612033, label: 'ELABORACION DE PASTA Y PRODUCTOS DE MADERA, PAPEL Y CARTON' },
  { value: 612034, label: 'EDICIONES Y PUBLICACIONES' },
  { value: 612035, label: 'IMPRESION' },
  { value: 612036, label: 'SERVICIOS RELACIONADOS CON LA EDICION Y LA IMPRESION' },
  { value: 612037, label: 'REPRODUCCION DE GRABACIONES' },
  { value: 612038, label: 'ELABORACION DE PRODUCTOS DE HORNO DE COQUE' },
  { value: 612039, label: 'ELABORACION DE PRODUCTOS DE LA REFINACION DE PETROLEO' },
  { value: 612040, label: 'ELABORACION DE SUSTANCIAS QUIMICAS BASICAS' },
  { value: 612041, label: 'ELABORACION DE ABONOS Y COMPUESTOS DE NITROGENO' },
  { value: 612042, label: 'ELABORACION DE PLASTICO Y CAUCHO SINTETICO' },
  { value: 612043, label: 'ELABORACION DE PRODUCTOS QUIMICOS DE USO AGROPECUARIO' },
  { value: 612044, label: 'ELABORACION DE PINTURAS, TINTAS Y MASILLAS' },
  { value: 612045, label: 'ELABORACION DE PRODUCTOS FARMACEUTICOS Y BOTANICOS' },
  { value: 612046, label: 'ELABORACION DE JABONES, DETERGENTES Y PREPARADOS DE TOCADOR' },
  { value: 612047, label: 'ELABORACION DE OTROS PRODUCTOS QUIMICOS' },
  { value: 612048, label: 'ELABORACION DE FIBRAS' },
  { value: 612049, label: 'ELABORACION DE OTROS PRODUCTOS DE CAUCHO' },
  { value: 612050, label: 'ELABORACION DE PRODUCTOS DE PLASTICO' },
  { value: 612051, label: 'ELABORACION DE VIDRIO Y PRODUCTOS DE VIDRIO' },
  { value: 612052, label: 'ELABORACION DE PRODUCTOS DE CERAMICA, LOZA, PIEDRA, ARCILLA Y PORCELANA' },
  { value: 612053, label: 'ELABORACION DE CEMENTO, CAL Y YESO' },
  { value: 612054, label: 'ELABORACION DE ARTICULOS DE HORMIGON, CEMENTO Y YESO' },
  { value: 612055, label: 'CORTE, TALLADO Y ACABADO DE LA PIEDRA' },
  { value: 612056, label: 'ELABORACION DE OTROS PRODUCTOS MINERALES NO METALICOS' },
  { value: 612057, label: 'INDUSTRIAS BASICAS Y FUNDICION DE HIERRO Y ACERO' },
  { value: 612058, label: 'PRODUCTOS PRIMARIOS DE METALES PRECIOSOS Y DE METALES NO FERROSOS' },
  { value: 612059, label: 'FUNDICION DE METALES NO FERROSOS' },
  { value: 612060, label: 'FABRICACION DE PRODUCTOS METALICOS PARA USO ESTRUCTURAL' },
  { value: 612061, label: 'FORJA, PRENSADO, ESTAMPADO, LAMINADO DE METAL Y PULVIMETALURGIA' },
  { value: 612062, label: 'REVESTIMIENTO DE METALES Y OBRAS DE INGENIERIA MECANICA' },
  { value: 612063, label: 'FABRICACION DE ARTICULOS DE FERRETERIA' },
  { value: 612064, label: 'ELABORACION DE OTROS PRODUCTOS DE METAL' },
  { value: 612065, label: 'FABRICACION DE MAQUINARIA Y EQUIPO' },
  { value: 612066, label: 'FABRICACION DE EQUIPOS DE ELEVACION Y MANIPULACION' },
  { value: 612067, label: 'ELABORACION DE APARATOS DE USO DOMESTICO' },
  { value: 612068, label: 'ELABORACION DE EQUIPO DE OFICINA' },
  { value: 612069, label: 'ELABORACION DE PILAS Y BATERIAS PRIMARIAS' },
  { value: 612070, label: 'ELABORACION DE EQUIPO DE ILUMINACION' },
  { value: 612071, label: 'ELABORACION DE OTROS TIPOS DE EQUIPO ELECTRICO' },
  { value: 612072, label: 'FABRICACION DE EQUIPOS DE RADIO, TELEVISION Y COMUNICACIONES' },
  { value: 612073, label: 'FABRICACION DE APARATOS E INSTRUMENTOS MEDICOS' },
  { value: 612074, label: 'FABRICACION DE INSTRUMENTOS DE MEDICION Y CONTROL' },
  { value: 612075, label: 'FABRICACION DE INSTRUMENTOS DE OPTICA Y EQUIPO FOTOGRAFICO' },
  { value: 612076, label: 'FABRICACION DE RELOJES' },
  { value: 612077, label: 'FABRICACION DE VEHICULOS AUTOMOTORES' },
  { value: 612078, label: 'FABRICACION DE CARROCERIAS PARA AUTOMOTORES' },
  { value: 612079, label: 'FABRICACION DE PARTES PIEZAS Y ACCESORIOS PARA AUTOMOTORES' },
  { value: 612080, label: 'FABRICACION Y REPARACION DE BUQUES Y OTRAS EMBARCACIONES' },
  { value: 612081, label: 'FABRICACION DE LOCOMOTORAS Y MATERIAL RODANTE PARA FERROCARRILES' },
  { value: 612082, label: 'FABRICACION DE AERONAVES' },
  { value: 612083, label: 'FABRICACION DE MOTOCICLETAS' },
  { value: 612084, label: 'FABRICACION DE BICICLETAS Y SILLAS DE RUEDAS' },
  { value: 612085, label: 'FABRICACION DE OTROS TIPOS DE TRANSPORTE' },
  { value: 612086, label: 'FABRICACION DE MUEBLES' },
  { value: 612087, label: 'FABRICACION DE JOYAS Y ARTICULOS CONEXOS' },
  { value: 612088, label: 'FABRICACION DE INSTRUMENTOS DE MUSICA' },
  { value: 612089, label: 'FABRICACION DE ARTICULOS Y EQUIPO PARA DEPORTE' },
  { value: 612090, label: 'FABRICACION DE JUEGOS Y JUGUETES' },
  { value: 612091, label: 'RECICLAMIENTO DE DESPERDICIOS' },
  { value: 612095, label: 'PRODUCTOS DE OTRAS INDUSTRIAS MANUFACTURERAS' },
  { value: 612099, label: 'AJUSTES POR INFLACION' },
  { value: 6125, label: 'SUMINISTRO DE ELECTRICIDAD, GAS Y AGUA' },
  { value: 612505, label: 'GENERACION, CAPTACION Y DISTRIBUCION DE ENERGIA ELECTRICA' },
  { value: 612510, label: 'FABRICACION DE GAS Y DISTRIBUCION DE COMBUSTIBLES GASEOSOS' },
  { value: 612515, label: 'CAPTACION, DEPURACION Y DISTRIBUCION DE AGUA' },
  { value: 612595, label: 'ACTIVIDADES CONEXAS' },
  { value: 612599, label: 'AJUSTES POR INFLACION' },
  { value: 6130, label: 'CONSTRUCCION' },
  { value: 613005, label: 'PREPARACION DE TERRENOS' },
  { value: 613010, label: 'CONSTRUCCION DE EDIFICIOS Y OBRAS DE INGENIERIA CIVIL' },
  { value: 613015, label: 'ACONDICIONAMIENTO DE EDIFICIOS' },
  { value: 613020, label: 'TERMINACION DE EDIFICACIONES' },
  { value: 613025, label: 'ALQUILER DE EQUIPO CON OPERARIO' },
  { value: 613095, label: 'ACTIVIDADES CONEXAS' },
  { value: 613099, label: 'AJUSTES POR INFLACION' },
  { value: 6135, label: 'COMERCIO AL POR MAYOR Y AL POR MENOR' },
  { value: 613502, label: 'VENTA DE VEHICULOS AUTOMOTORES' },
  { value: 613504, label: 'MANTENIMIENTO, REPARACION Y LAVADO DE VEHICULOS AUTOMOTORES' },
  { value: 613506, label: 'VENTA DE PARTES, PIEZAS Y ACCESORIOS DE VEHICULOS AUTOMOTORES' },
  { value: 613508, label: 'VENTA DE COMBUSTIBLES SOLIDOS, LIQUIDOS, GASEOSOS' },
  { value: 613510, label: 'VENTA DE LUBRICANTES, ADITIVOS, LLANTAS Y LUJOS PARA AUTOMOTORES' },
  { value: 613512, label: 'VENTA A CAMBIO DE RETRIBUCION O POR CONTRATA' },
  { value: 613514, label: 'VENTA DE INSUMOS, MATERIAS PRIMAS AGROPECUARIAS Y FLORES' },
  { value: 613516, label: 'VENTA DE OTROS INSUMOS Y MATERIAS PRIMAS NO AGROPECUARIAS' },
  { value: 613518, label: 'VENTA DE ANIMALES VIVOS Y CUEROS' },
  { value: 613520, label: 'VENTA DE PRODUCTOS EN ALMACENES NO ESPECIALIZADOS' },
  { value: 613522, label: 'VENTA DE PRODUCTOS AGROPECUARIOS' },
  { value: 613524, label: 'VENTA DE PRODUCTOS TEXTILES, DE VESTIR, DE CUERO Y CALZADO' },
  { value: 613526, label: 'VENTA DE PAPEL Y CARTON' },
  { value: 613528, label: 'VENTA DE LIBROS, REVISTAS, ELEMENTOS DE PAPELERIA, UTILES Y TEXTOS ESCOLARES' },
  { value: 613530, label: 'VENTA DE JUEGOS, JUGUETES Y ARTICULOS DEPORTIVOS' },
  { value: 613532, label: 'VENTA DE INSTRUMENTOS QUIRURGICOS Y ORTOPEDICOS' },
  { value: 613534, label: 'VENTA DE ARTICULOS EN RELOJERIAS Y JOYERIAS' },
  { value: 613536, label: 'VENTA DE ELECTRODOMESTICOS Y MUEBLES' },
  { value: 613538, label: 'VENTA DE PRODUCTOS DE ASEO, FARMACEUTICOS, MEDICINALES, Y ARTICULOS DE TOCADOR' },
  { value: 613540, label: 'VENTA DE CUBIERTOS, VAJILLAS, CRISTALERIA, PORCELANAS, CERAMICAS Y OTROS ARTICULOS DE USO DOMESTICO' },
  { value: 613542, label: 'VENTA DE MATERIALES DE CONSTRUCCION, FONTANERIA Y CALEFACCION' },
  { value: 613544, label: 'VENTA DE PINTURAS Y LACAS' },
  { value: 613546, label: 'VENTA DE PRODUCTOS DE VIDRIOS Y MARQUETERIA' },
  { value: 613548, label: 'VENTA DE HERRAMIENTAS Y ARTICULOS DE FERRETERIA' },
  { value: 613550, label: 'VENTA DE QUIMICOS' },
  { value: 613552, label: 'VENTA DE PRODUCTOS INTERMEDIOS, DESPERDICIOS Y DESECHOS' },
  { value: 613554, label: 'VENTA DE MAQUINARIA, EQUIPO DE OFICINA Y PROGRAMAS DE COMPUTADOR' },
  { value: 613556, label: 'VENTA DE ARTICULOS EN CACHARRERIAS Y MISCELANEAS' },
  { value: 613558, label: 'VENTA DE INSTRUMENTOS MUSICALES' },
  { value: 613560, label: 'VENTA DE ARTICULOS EN CASAS DE EMPEÑO Y PRENDERIAS' },
  { value: 613562, label: 'VENTA DE EQUIPO FOTOGRAFICO' },
  { value: 613564, label: 'VENTA DE EQUIPO OPTICO Y DE PRECISION' },
  { value: 613566, label: 'VENTA DE EMPAQUES' },
  { value: 613568, label: 'VENTA DE EQUIPO PROFESIONAL Y CIENTIFICO' },
  //{ value: 613570, label: 'VENTA DE LOTERIAS, RIFAS, CHANCE, APUESTAS Y SIMILARES' },
  { value: 613572, label: 'REPARACION DE EFECTOS PERSONALES Y ELECTRODOMESTICOS' },
  { value: 613595, label: 'VENTA DE OTROS PRODUCTOS' },
  { value: 613599, label: 'AJUSTES POR INFLACION' },
  { value: 6140, label: 'HOTELES Y RESTAURANTES' },
  { value: 614005, label: 'HOTELERIA' },
  { value: 614010, label: 'CAMPAMENTO Y OTROS TIPOS DE HOSPEDAJE' },
  { value: 614015, label: 'RESTAURANTES' },
  { value: 614020, label: 'BARES Y CANTINAS' },
  { value: 614095, label: 'ACTIVIDADES CONEXAS' },
  { value: 614099, label: 'AJUSTES POR INFLACION' },
  { value: 6145, label: 'TRANSPORTE, ALMACENAMIENTO Y COMUNICACIONES' },
  { value: 614505, label: 'SERVICIO DE TRANSPORTE POR CARRETERA' },
  { value: 614510, label: 'SERVICIO DE TRANSPORTE POR VIA FERREA' },
  { value: 614515, label: 'SERVICIO DE TRANSPORTE POR VIA ACUATICA' },
  { value: 614520, label: 'SERVICIO DE TRANSPORTE POR VIA AEREA' },
  { value: 614525, label: 'SERVICIO DE TRANSPORTE POR TUBERIAS' },
  { value: 614530, label: 'MANIPULACION DE CARGA' },
  { value: 614535, label: 'ALMACENAMIENTO Y DEPOSITO' },
  { value: 614540, label: 'SERVICIOS COMPLEMENTARIOS PARA EL TRANSPORTE' },
  { value: 614545, label: 'AGENCIAS DE VIAJE' },
  { value: 614550, label: 'OTRAS AGENCIAS DE TRANSPORTE' },
  { value: 614555, label: 'SERVICIO POSTAL Y DE CORREO' },
  { value: 614560, label: 'SERVICIO TELEFONICO' },
  { value: 614565, label: 'SERVICIO DE TELEGRAFO' },
  { value: 614570, label: 'SERVICIO DE TRANSMISION DE DATOS' },
  { value: 614575, label: 'SERVICIO DE RADIO Y TELEVISION POR CABLE' },
  { value: 614580, label: 'TRANSMISION DE SONIDO E IMAGENES POR CONTRATO' },
  { value: 614595, label: 'ACTIVIDADES CONEXAS' },
  { value: 614599, label: 'AJUSTES POR INFLACION' },
  { value: 6150, label: 'ACTIVIDAD FINANCIERA' },
  { value: 615005, label: 'DE INVERSIONES' },
  { value: 615010, label: 'DE SERVICIO DE BOLSA' },
  { value: 615099, label: 'AJUSTES POR INFLACION' },
  { value: 6155, label: 'ACTIVIDADES INMOBILIARIAS, EMPRESARIALES Y DE ALQUILER' },
  { value: 615505, label: 'ARRENDAMIENTOS DE BIENES INMUEBLES' },
  { value: 615510, label: 'INMOBILIARIAS POR RETRIBUCION O CONTRATA' },
  { value: 615515, label: 'ALQUILER EQUIPO DE TRANSPORTE' },
  { value: 615520, label: 'ALQUILER MAQUINARIA Y EQUIPO' },
  { value: 615525, label: 'ALQUILER DE EFECTOS PERSONALES Y ENSERES DOMESTICOS' },
  { value: 615530, label: 'CONSULTORIA EN EQUIPO Y PROGRAMAS DE INFORMATICA' },
  { value: 615535, label: 'PROCESAMIENTO DE DATOS' },
  { value: 615540, label: 'MANTENIMIENTO Y REPARACION DE MAQUINARIA DE OFICINA' },
  { value: 615545, label: 'INVESTIGACIONES CIENTIFICAS Y DE DESARROLLO' },
  { value: 615550, label: 'ACTIVIDADES EMPRESARIALES DE CONSULTORIA' },
  { value: 615555, label: 'PUBLICIDAD' },
  { value: 615560, label: 'DOTACION DE PERSONAL' },
  { value: 615565, label: 'INVESTIGACION Y SEGURIDAD' },
  { value: 615570, label: 'LIMPIEZA DE INMUEBLES' },
  { value: 615575, label: 'FOTOGRAFIA' },
  { value: 615580, label: 'ENVASE Y EMPAQUE' },
  { value: 615585, label: 'FOTOCOPIADO' },
  { value: 615590, label: 'MANTENIMIENTO Y REPARACION DE MAQUINARIA Y EQUIPO' },
  { value: 615595, label: 'ACTIVIDADES CONEXAS' },
  { value: 615599, label: 'AJUSTES POR INFLACION' },
  { value: 6160, label: 'ENSEÑANZA' },
  { value: 616005, label: 'ACTIVIDADES RELACIONADAS CON LA EDUCACION' },
  { value: 616099, label: 'AJUSTES POR INFLACION' },
  { value: 6165, label: 'SERVICIOS SOCIALES Y DE SALUD' },
  { value: 616505, label: 'SERVICIO HOSPITALARIO' },
  { value: 616510, label: 'SERVICIO MEDICO' },
  { value: 616515, label: 'SERVICIO ODONTOLOGICO' },
  { value: 616520, label: 'SERVICIO DE LABORATORIO' },
  { value: 616525, label: 'ACTIVIDADES VETERINARIAS' },
  { value: 616530, label: 'ACTIVIDADES DE SERVICIOS SOCIALES' },
  { value: 616595, label: 'ACTIVIDADES CONEXAS' },
  { value: 616599, label: 'AJUSTES POR INFLACION' },
  { value: 6170, label: 'OTRAS ACTIVIDADES DE SERVICIOS COMUNITARIOS, SOCIALES Y PERSONALES' },
  { value: 617005, label: 'ELIMINACION DE DESPERDICIOS Y AGUAS RESIDUALES' },
  { value: 617010, label: 'ACTIVIDADES DE ASOCIACION' },
  { value: 617015, label: 'PRODUCCION Y DISTRIBUCION DE FILMES Y VIDEOCINTAS' },
  { value: 617020, label: 'EXHIBICION DE FILMES Y VIDEOCINTAS' },
  { value: 617025, label: 'ACTIVIDAD DE RADIO Y TELEVISION' },
  { value: 617030, label: 'ACTIVIDAD TEATRAL, MUSICAL Y ARTISTICA' },
  { value: 617035, label: 'GRABACION Y PRODUCCION DE DISCOS' },
  { value: 617040, label: 'ENTRETENIMIENTO Y ESPARCIMIENTO' },
  { value: 617045, label: 'AGENCIAS DE NOTICIAS' },
  { value: 617050, label: 'LAVANDERIAS Y SIMILARES' },
  { value: 617055, label: 'PELUQUERIAS Y SIMILARES' },
  { value: 617060, label: 'SERVICIOS FUNERARIOS' },
  { value: 617065, label: 'ZONAS FRANCAS' },
  { value: 617095, label: 'ACTIVIDADES CONEXAS' },
  { value: 617099, label: 'AJUSTES POR INFLACION' },
  { value: 62, label: 'COMPRAS' },
  { value: 6205, label: 'DE MERCANCIAS' },
  { value: 620599, label: 'AJUSTES POR INFLACION' },
  { value: 6210, label: 'DE MATERIAS PRIMAS' },
  { value: 621099, label: 'AJUSTES POR INFLACION' },
  { value: 6215, label: 'DE MATERIALES INDIRECTOS' },
  { value: 621599, label: 'AJUSTES POR INFLACION' },
  { value: 6220, label: 'COMPRA DE ENERGIA' },
  { value: 622001, label: 'a 622098' },
  { value: 622099, label: 'AJUSTES POR INFLACION' },
  { value: 6225, label: 'DEVOLUCIONES REBAJAS Y DESCUENTOS EN COMPRAS (CR)' },
  { value: 622599, label: 'AJUSTES POR INFLACION' },
  { value: 7, label: 'COSTOS DE PRODUCCION O DE OPERACION' },
  { value: 71, label: 'MATERIA PRIMA' },
  { value: 72, label: 'MANO DE OBRA DIRECTA' },
  { value: 73, label: 'COSTOS INDIRECTOS' },
  { value: 74, label: 'CONTRATOS DE SERVICIOS' },
  { value: 8, label: 'CUENTAS DE ORDEN DEUDORAS' },
  { value: 81, label: 'DERECHOS CONTINGENTES' },
  { value: 8105, label: 'BIENES Y VALORES ENTREGADOS EN CUSTODIA' },
  { value: 810505, label: 'VALORES MOBILIARIOS' },
  { value: 810510, label: 'BIENES MUEBLES' },
  { value: 810599, label: 'AJUSTES POR INFLACION' },
  { value: 8110, label: 'BIENES Y VALORES ENTREGADOS EN GARANTIA' },
  { value: 811005, label: 'VALORES MOBILIARIOS' },
  { value: 811010, label: 'BIENES MUEBLES' },
  { value: 811015, label: 'BIENES INMUEBLES' },
  { value: 811020, label: 'CONTRATOS DE GANADO EN PARTICIPACION' },
  { value: 811099, label: 'AJUSTES POR INFLACION' },
  { value: 8115, label: 'BIENES Y VALORES EN PODER DE TERCEROS' },
  { value: 811505, label: 'EN ARRENDAMIENTO' },
  { value: 811510, label: 'EN PRESTAMO' },
  { value: 811515, label: 'EN DEPOSITO' },
  { value: 811520, label: 'EN CONSIGNACION' },
  { value: 811599, label: 'AJUSTES POR INFLACION' },
  { value: 8120, label: 'LITIGIOS Y/O DEMANDAS' },
  { value: 812005, label: 'EJECUTIVOS' },
  { value: 812010, label: 'INCUMPLIMIENTO DE CONTRATOS' },
  { value: 8125, label: 'PROMESAS DE COMPRAVENTA' },
  { value: 8195, label: 'DIVERSAS' },
  { value: 819505, label: 'VALORES ADQUIRIDOS POR RECIBIR' },
  { value: 819595, label: 'OTRAS' },
  { value: 819599, label: 'AJUSTES POR INFLACION.' },
  { value: 82, label: 'DEUDORAS FISCALES' },
  { value: 83, label: 'DEUDORAS DE CONTROL' },
  { value: 8305, label: 'BIENES RECIBIDOS EN ARRENDAMIENTO FINANCIERO' },
  { value: 830505, label: 'BIENES MUEBLES' },
  { value: 830510, label: 'BIENES INMUEBLES' },
  { value: 830599, label: 'AJUSTES POR INFLACION' },
  { value: 8310, label: 'TITULOS DE INVERSION NO COLOCADOS' },
  { value: 831005, label: 'ACCIONES' },
  { value: 831010, label: 'BONOS' },
  { value: 831095, label: 'OTROS' },
  { value: 8315, label: 'PROPIEDADES PLANTA Y EQUIPO TOTALMENTE DEPRECIADOS, AGOTADOS Y/O AMORTIZADOS' },
  { value: 831506, label: 'MATERIALES PROYECTOS PETROLEROS' },
  { value: 831516, label: 'CONSTRUCCIONES Y EDIFICACIONES' },
  { value: 831520, label: 'MAQUINARIA Y EQUIPO' },
  { value: 831524, label: 'EQUIPO DE OFICINA' },
  { value: 831528, label: 'EQUIPO DE COMPUTACION Y COMUNICACION' },
  { value: 831532, label: 'EQUIPO MEDICO - CIENTIFICO' },
  { value: 831536, label: 'EQUIPO DE HOTELES Y RESTAURANTES' },
  { value: 831540, label: 'FLOTA Y EQUIPO DE TRANSPORTE' },
  { value: 831544, label: 'FLOTA Y EQUIPO FLUVIAL Y/O MARITIMO' },
  { value: 831548, label: 'FLOTA Y EQUIPO AEREO' },
  { value: 831552, label: 'FLOTA Y EQUIPO FERREO' },
  { value: 831556, label: 'ACUEDUCTOS, PLANTAS Y REDES' },
  { value: 831560, label: 'ARMAMENTO DE VIGILANCIA' },
  { value: 831562, label: 'ENVASES Y EMPAQUES' },
  { value: 831564, label: 'PLANTACIONES AGRICOLAS Y FORESTALES' },
  { value: 831568, label: 'VIAS DE COMUNICACION' },
  { value: 831572, label: 'MINAS Y CANTERAS' },
  { value: 831576, label: 'POZOS ARTESIANOS' },
  { value: 831580, label: 'YACIMIENTOS' },
  { value: 831584, label: 'SEMOVIENTES' },
  { value: 831599, label: 'AJUSTES POR INFLACION' },
  { value: 8320, label: 'CREDITOS A FAVOR NO UTILIZADOS' },
  { value: 832005, label: 'PAIS' },
  { value: 832010, label: 'EXTERIOR' },
  { value: 8325, label: 'ACTIVOS CASTIGADOS' },
  { value: 832505, label: 'INVERSIONES' },
  { value: 832510, label: 'DEUDORES' },
  { value: 832595, label: 'OTROS ACTIVOS' },
  { value: 8330, label: 'TITULOS DE INVERSION AMORTIZADOS' },
  { value: 833005, label: 'BONOS' },
  { value: 833095, label: 'OTROS' },
  { value: 8335, label: 'CAPITALIZACION POR REVALORIZACION DE PATRIMONIO' },
  { value: 8395, label: 'OTRAS CUENTAS DEUDORAS DE CONTROL' },
  { value: 839505, label: 'CHEQUES POSTFECHADOS' },
  { value: 839510, label: 'CERTIFICADOS DE DEPOSITO A TERMINO' },
  { value: 839515, label: 'CHEQUES DEVUELTOS' },
  { value: 839520, label: 'BIENES Y VALORES EN FIDEICOMISO' },
  { value: 839525, label: 'INTERESES SOBRE DEUDAS VENCIDAS' },
  { value: 839595, label: 'DIVERSAS' },
  { value: 839599, label: 'AJUSTES POR INFLACION' },
  { value: 8399, label: 'AJUSTES POR INFLACION ACTIVOS' },
  { value: 839905, label: 'INVERSIONES' },
  { value: 839910, label: 'INVENTARIOS' },
  { value: 839915, label: 'PROPIEDADES PLANTA Y EQUIPO' },
  { value: 839920, label: 'INTANGIBLES' },
  { value: 839925, label: 'CARGOS DIFERIDOS' },
  { value: 839995, label: 'OTROS ACTIVOS' },
  { value: 84, label: 'DERECHOS CONTINGENTES POR CONTRA (CR)' },
  { value: 85, label: 'DEUDORAS FISCALES POR CONTRA (CR)' },
  { value: 86, label: 'DEUDORAS DE CONTROL POR CONTRA (CR)' },
  { value: 9, label: 'CUENTAS DE ORDEN ACREEDORAS' },
  { value: 91, label: 'RESPONSABILIDADES CONTINGENTES' },
  { value: 9105, label: 'BIENES Y VALORES RECIBIDOS EN CUSTODIA' },
  { value: 910505, label: 'VALORES MOBILIARIOS' },
  { value: 910510, label: 'BIENES MUEBLES' },
  { value: 910599, label: 'AJUSTES POR INFLACION' },
  { value: 9110, label: 'BIENES Y VALORES RECIBIDOS EN GARANTIA' },
  { value: 911005, label: 'VALORES MOBILIARIOS' },
  { value: 911010, label: 'BIENES MUEBLES' },
  { value: 911015, label: 'BIENES INMUEBLES' },
  { value: 911020, label: 'CONTRATOS DE GANADO EN PARTICIPACION' },
  { value: 911099, label: 'AJUSTES POR INFLACION' },
  { value: 9115, label: 'BIENES Y VALORES RECIBIDOS DE TERCEROS' },
  { value: 911505, label: 'EN ARRENDAMIENTO' },
  { value: 911510, label: 'EN PRESTAMO' },
  { value: 911515, label: 'EN DEPOSITO' },
  { value: 911520, label: 'EN CONSIGNACION' },
  { value: 911525, label: 'EN COMODATO' },
  { value: 911599, label: 'AJUSTES POR INFLACION' },
  { value: 9120, label: 'LITIGIOS Y/O DEMANDAS' },
  { value: 912005, label: 'LABORALES' },
  { value: 912010, label: 'CIVILES' },
  { value: 912015, label: 'ADMINISTRATIVOS O ARBITRALES' },
  { value: 912020, label: 'TRIBUTARIOS' },
  { value: 9125, label: 'PROMESAS DE COMPRAVENTA' },
  { value: 9130, label: 'CONTRATOS DE ADMINISTRACION DELEGADA' },
  { value: 9135, label: 'CUENTAS EN PARTICIPACION' },
  { value: 9195, label: 'OTRAS RESPONSABILIDADES CONTINGENTES' },
  { value: 92, label: 'ACREEDORAS FISCALES' },
  { value: 93, label: 'ACREEDORAS DE CONTROL' },
  { value: 9305, label: 'CONTRATOS DE ARRENDAMIENTO FINANCIERO' },
  { value: 930505, label: 'BIENES MUEBLES' },
  { value: 930510, label: 'BIENES INMUEBLES' },
  { value: 9395, label: 'OTRAS CUENTAS DE ORDEN ACREEDORAS DE CONTROL' },
  { value: 939505, label: 'DOCUMENTOS POR COBRAR DESCONTADOS' },
  { value: 939510, label: 'CONVENIOS DE PAGO' },
  { value: 939515, label: 'CONTRATOS DE CONSTRUCCIONES E INSTALACIONES POR EJECUTAR' },
  { value: 939520, label: 'PEDIDOS COLOCADOS' },
  { value: 939525, label: 'ADJUDICACIONES PENDIENTES DE LEGALIZAR' },
  { value: 939530, label: 'RESERVA ARTICULO 3o. LEY 4/80' },
  { value: 939535, label: 'RESERVA COSTO REPOSICION SEMOVIENTES' },
  { value: 939599, label: 'AJUSTES POR INFLACION' },
  { value: 9399, label: 'AJUSTES POR INFLACION PATRIMONIO' },
  { value: 939905, label: 'CAPITAL SOCIAL' },
  { value: 939910, label: 'SUPERAVIT DE CAPITAL' },
  { value: 939915, label: 'RESERVAS' },
  { value: 939925, label: 'DIVIDENDOS O PARTICIPACIONES DECRETADAS EN ACCIONES, CUOTAS O PARTES DE INTERES SOCIAL' },
  { value: 939930, label: 'RESULTADOS DE EJERCICIOS ANTERIORES' },
  { value: 94, label: 'RESPONSABILIDADES CONTINGENTES POR CONTRA (DB)' },
  { value: 95, label: 'ACREEDORAS FISCALES POR CONTRA (DB)' },
  { value: 96, label: 'ACREEDORAS DE CONTROL POR CONTRA (DB)' }
];

export const generalConceptsValueLabelList = pucList.map(({ value, label }) => ({ value, label: `${value}-${label}` }));
/* .filter(({ value }) => value.length === 4) */

export const generalConceptValueLabelsObject = pucList.reduce(
  (prev, { value, label }) => ({ ...prev, [value]: `${value}-${label}` }),
  {}
);

export const generalConceptsValueLabelObject = pucList.reduce((prev, { value, label }) => {
  if (value.length === 4) {
    if (!prev[value]) {
      prev[value] = [];
    }
  } else if (value.length === 6) {
    const key = value.slice(0, 4);
    if (prev[key]) {
      prev[key].push({ value, label: `${value}-${label}` });
    }
  }
  return prev;
}, {});

export const getSpecificConceptsOptionsByKey = generalConcept => {
  return generalConceptsValueLabelObject[generalConcept] ? generalConceptsValueLabelObject[generalConcept] : [];
};
